(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function stripHtml(html) {
    if (!html) return '';
    var el = document.createElement('div');
    el.innerHTML = String(html);
    return el.textContent || el.innerText || '';
  }

  function normalizeDesignToken(token) {
    var str = String(token || '');
    if (typeof theme !== 'undefined' && typeof theme.normalizeBuilderLetters === 'function') {
      return theme.normalizeBuilderLetters(str);
    }
    return str.replace(/\u271D\uFE0F?/g, '\u2020').replace(/\u2721\uFE0F?/g, '\u2020');
  }

  function formatMoney(cents, moneyFormat) {
    var amount = Number(cents) || 0;
    var formatted;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      formatted = Shopify.formatMoney(amount, moneyFormat);
    } else {
      formatted = '£' + (amount / 100).toFixed(2);
    }
    return stripHtml(formatted);
  }

  function countCharmsForVariant(selectedCharms, variantId) {
    return selectedCharms.filter(function (c) {
      return c && Number(c.id) === Number(variantId);
    }).length;
  }

  function parseInventoryQuantity(value) {
    var parsed = parseInt(String(value), 10);
    if (isNaN(parsed)) return null;
    return parsed;
  }

  function configureBuilderImage(img) {
    img.draggable = false;
    return img;
  }

  function generateBuilderId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'builder-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
  }

  function parsePositiveInt(value) {
    if (value === null || value === undefined || value === '') return null;
    var parsed = parseInt(String(value), 10);
    if (isNaN(parsed) || parsed < 0) return null;
    return parsed;
  }

  function parseBootstrap() {
    var el = document.getElementById('product-builder-bootstrap');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[ProductBuilder] Failed to parse bootstrap JSON', e);
      return null;
    }
  }

  var BUILDER_ADD_TO_BAG_SPINNER =
    '<svg style="margin-top:2px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">' +
      '<g transform="translate(0, 0)"><g class="nc-loop-circle-3-16-icon-f">' +
        '<path d="M8 16a8 8 0 1 1 8-8 1 1 0 0 1-2 0 6 6 0 1 0-1.8 4.286 1 1 0 1 1 1.4 1.428A7.956 7.956 0 0 1 8 16z" fill="#ffffff"></path>' +
      '</g>' +
      '<style>.nc-loop-circle-3-16-icon-f{--animation-duration:0.7s;transform-origin:8px 8px;animation:nc-loop-circle-3-anim var(--animation-duration) infinite linear}@keyframes nc-loop-circle-3-anim{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style>' +
    '</g></svg>';

  function setAddToBagButtonLoading(btn, isLoading, label) {
    if (!btn) return;

    if (isLoading) {
      if (!btn.dataset.builderDefaultLabel) {
        btn.dataset.builderDefaultLabel = label || btn.textContent.trim();
      }
      btn.disabled = true;
      btn.innerHTML = BUILDER_ADD_TO_BAG_SPINNER;
      return;
    }

    btn.disabled = false;
    btn.textContent = label || btn.dataset.builderDefaultLabel || 'Add to bag';
  }

  function ProductBuilder(root, data) {
    this.root = root;
    this.data = data;
    this.config = data.config || {};
    this.placement = this.config.placement || {};
    this.normalizePlacementConfig();
    this.charmGroups = data.charm_groups || [];
    this.charmGroup = this.charmGroups[0] || null;
    this.charmTiles = [];
    this.cartVariantCounts = {};
    this.selectedCharms = [];
    this.builderId = null;
    this.step = 'product';
    this.baseVariantId = this.getInitialVariantId();
    this.dragFromIndex = null;
    this.dragInsertIndex = null;
    this.draggingEl = null;
    this.dropPlaceholder = null;
    this.dragCloneEl = null;
    this.dragPointerId = null;
    this.dragActive = false;
    this.previewCharmStates = {};
    this.scrollLockActive = false;
    this.scrollLockScrollY = 0;
    this.scrollbarGap = 0;
    this.panelTransitionTimer = null;
    this.pendingEngraveTile = null;
    this.supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    this.els = {
      launch: document.querySelector('[data-builder-launch]'),
      workspace: root.querySelector('.product-builder__workspace'),
      baseImage: root.querySelector('[data-builder-base-image]'),
      charmsLayer: root.querySelector('[data-builder-charms-layer]'),
      charmGrid: root.querySelector('[data-builder-charm-grid]'),
      panelChoose: root.querySelector('[data-builder-panel-choose]'),
      panelReview: root.querySelector('[data-builder-panel-review]'),
      panelStack: root.querySelector('.product-builder__panel-stack'),
      panelTitle: root.querySelector('[data-builder-panel-title]'),
      complementaryNote: root.querySelector('[data-builder-complementary-note]'),
      bespokeCharms: root.querySelector('[data-builder-bespoke-charms]'),
      bespokeCharmsToggle: root.querySelector('[data-builder-bespoke-charms-toggle]'),
      bespokeCharmsMessage: root.querySelector('[data-builder-bespoke-charms-message]'),
      charmCounterText: root.querySelector('[data-builder-charm-counter-text]'),
      reviewList: root.querySelector('[data-builder-review-list]'),
      backBtn: root.querySelector('[data-builder-back]'),
      reviewBtn: root.querySelector('[data-builder-review-btn]'),
      addToBagBtn: root.querySelector('[data-builder-add-to-bag]'),
      editBtn: root.querySelector('[data-builder-go-edit]'),
      addFirstCharm: root.querySelector('[data-builder-add-first-charm]'),
      editTray: root.querySelector('[data-builder-edit-tray]'),
      editBackdrop: root.querySelector('[data-builder-edit-backdrop]'),
      engraveTray: root.querySelector('[data-builder-engrave-tray]'),
      engraveBackdrop: root.querySelector('[data-builder-engrave-backdrop]'),
      engraveTitle: root.querySelector('[data-builder-engrave-title]'),
      engraveGallery: root.querySelector('[data-builder-engrave-gallery]'),
      engraveGalleryTrack: root.querySelector('[data-builder-engrave-gallery-track]'),
      engraveHint: root.querySelector('[data-builder-engrave-hint]'),
      engraveLabel: root.querySelector('[data-builder-engrave-label]'),
      engraveMax: root.querySelector('[data-builder-engrave-max]'),
      engraveInput: root.querySelector('[data-builder-engrave-input]'),
      engraveError: root.querySelector('[data-builder-engrave-error]'),
      engraveNotes: root.querySelector('[data-builder-engrave-notes]'),
      engraveNotesTitle: root.querySelector('[data-builder-engrave-notes-title]'),
      engraveNotesList: root.querySelector('[data-builder-engrave-notes-list]'),
      closeEngrave: root.querySelector('[data-builder-close-engrave]'),
      engraveSkip: root.querySelector('[data-builder-engrave-skip]'),
      engraveConfirm: root.querySelector('[data-builder-engrave-confirm]'),
      selectedCharms: root.querySelector('[data-builder-selected-charms]'),
      closeEdit: root.querySelector('[data-builder-close-edit]'),
      editHint: root.querySelector('[data-builder-edit-hint]'),
      saveEdit: root.querySelector('[data-builder-save-edit]'),
      startOrder: root.querySelector('[data-builder-start-order]'),
      priceTooltip: root.querySelector('[data-builder-price-tooltip]'),
      sidebarFooter: root.querySelector('[data-builder-sidebar-footer]'),
      runningTotal: root.querySelector('[data-builder-running-total]'),
      runningTotalValue: root.querySelector('[data-builder-running-total-value]'),
      charmValidation: root.querySelector('[data-builder-charm-validation]'),
      previewCol: root.querySelector('.product-builder__preview-col')
    };
  }

  ProductBuilder.prototype.getInitialVariantId = function () {
    var variants = this.data.base.variants || [];
    var available = variants.find(function (v) {
      return this.isVariantPurchasable(v);
    }, this);
    return (available || variants[0] || {}).id || null;
  };

  ProductBuilder.prototype.getBaseVariant = function () {
    var id = Number(this.baseVariantId);
    return (this.data.base.variants || []).find(function (v) {
      return Number(v.id) === id;
    }) || null;
  };

  ProductBuilder.prototype.isVariantPurchasable = function (variant) {
    if (!variant) return false;
    if (variant.available) return true;
    if (variant.inventory_policy === 'continue') return true;
    return false;
  };

  ProductBuilder.prototype.isBaseVariantAvailable = function () {
    var variant = this.getBaseVariant();
    if (!variant) return false;

    var live = (window.variants || []).find(function (v) {
      return Number(v.id) === Number(variant.id);
    });

    return this.isVariantPurchasable(live || variant);
  };

  ProductBuilder.prototype.getVariantSnapshotSources = function () {
    var sources = [];

    if (window.variants && window.variants.length) {
      sources.push(window.variants);
    }

    if (this.data.base && this.data.base.variants) {
      sources.push(this.data.base.variants);
    }

    var productJson = document.querySelector('[data-product-json]');
    if (productJson && productJson.textContent) {
      try {
        var parsed = JSON.parse(productJson.textContent);
        if (parsed.variants && parsed.variants.length) {
          sources.push(parsed.variants);
        }
      } catch (e) {
        /* ignore */
      }
    }

    return sources;
  };

  ProductBuilder.prototype.findVariantSnapshot = function (variantId) {
    var id = Number(variantId);
    if (!id) return null;

    var sources = this.getVariantSnapshotSources();
    var i;
    var match;

    for (i = 0; i < sources.length; i++) {
      match = sources[i].find(function (variant) {
        return Number(variant.id) === id;
      });
      if (match) return match;
    }

    for (i = 0; i < this.charmGroups.length; i++) {
      var group = this.charmGroups[i];
      var variants = group.variants || [];
      var j;

      for (j = 0; j < variants.length; j++) {
        if (Number(variants[j].id) === id) return variants[j];
      }

      if (group.products) {
        for (j = 0; j < group.products.length; j++) {
          var productVariants = group.products[j].variants || [];
          var k;
          for (k = 0; k < productVariants.length; k++) {
            if (Number(productVariants[k].id) === id) return productVariants[k];
          }
        }
      }
    }

    return null;
  };

  ProductBuilder.prototype.syncVariantInventory = function (variant, live, options) {
    options = options || {};
    if (!variant) return variant;

    var snapshot = this.findVariantSnapshot((live && live.id) || variant.id);
    if (snapshot) {
      if (snapshot.inventory_policy) variant.inventory_policy = snapshot.inventory_policy;
      if (snapshot.inventory_management) variant.inventory_management = snapshot.inventory_management;
      if (snapshot.inventory_quantity != null) variant.inventory_quantity = snapshot.inventory_quantity;
    }

    if (live) {
      if (live.inventory_policy) variant.inventory_policy = live.inventory_policy;
      if (live.inventory_management) variant.inventory_management = live.inventory_management;
      if (live.inventory_quantity != null) variant.inventory_quantity = live.inventory_quantity;
      if (live.price != null) variant.price = live.price;
      if (live.available != null) variant.available = live.available;
    }

    variant.available = this.isVariantPurchasable(variant);
    return variant;
  };

  ProductBuilder.prototype.applyBaseVariantFromLive = function (liveVariant) {
    if (!liveVariant) return;

    this.baseVariantId = Number(liveVariant.id);

    var base = this.getBaseVariant();
    if (base) {
      this.syncVariantInventory(base, liveVariant);
    }

    this.updateBasePreview();
    this.updateRunningTotal();
  };

  ProductBuilder.prototype.syncVariantFromOptionSelectors = function () {
    var variants = window.variants || this.data.base.variants || [];
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection || !variants.length) return;

    var selectedOptions = [];
    var positionsSeen = {};

    productSection.querySelectorAll('[data-single-option-selector]').forEach(function (el) {
      var index = el.dataset.index;
      if (!index || index.indexOf('option') !== 0) return;

      var pos = Number(index.replace('option', '')) - 1;
      if (positionsSeen[pos]) return;
      positionsSeen[pos] = true;
      selectedOptions[pos] = el.value;
    });

    var match = variants.find(function (variant) {
      return selectedOptions.every(function (value, index) {
        if (!value) return true;
        return variant['option' + (index + 1)] === value;
      });
    });

    if (match) {
      this.applyBaseVariantFromLive(match);
    }
  };

  ProductBuilder.prototype.syncBaseVariantAvailability = function (variant) {
    if (!variant) return;
    this.applyBaseVariantFromLive(variant);
  };

  ProductBuilder.prototype.updateLaunchButton = function () {
    if (!this.els.launch) return;

    var available = this.isBaseVariantAvailable();
    var soldOutBtn = document.querySelector('.klaviyo-bis-trigger.sold-out-btn');

    if (available) {
      this.els.launch.style.display = '';
      this.els.launch.disabled = false;
      this.els.launch.removeAttribute('disabled');
      if (soldOutBtn) soldOutBtn.style.display = 'none';
      return;
    }

    this.els.launch.style.display = 'none';
    this.els.launch.disabled = true;
    if (soldOutBtn) soldOutBtn.style.display = '';
  };

  ProductBuilder.prototype.getCharmVariant = function (variantId) {
    return this.charmTiles.find(function (tile) {
      return Number(tile.id) === Number(variantId);
    }) || null;
  };

  ProductBuilder.prototype.isVariantStockTracked = function (tileData) {
    if (!tileData || tileData.inventory_policy === 'continue') return false;
    if (tileData.inventory_management === 'shopify') return true;

    // Liquid bootstrap may include quantity even when management field is absent
    var quantity = parseInventoryQuantity(tileData.inventory_quantity);
    return quantity !== null && tileData.inventory_policy === 'deny';
  };

  ProductBuilder.prototype.getVariantStockCap = function (tileData) {
    if (!tileData || !this.isVariantPurchasable(tileData)) return 0;
    if (!this.isVariantStockTracked(tileData)) return null;

    var quantity = parseInventoryQuantity(tileData.inventory_quantity);
    if (quantity === null) return null;

    var inCart = 0;
    if (this.cartVariantCounts) {
      inCart = this.cartVariantCounts[String(tileData.id)] || 0;
    }

    return Math.max(0, quantity - inCart);
  };

  ProductBuilder.prototype.canAddCharmVariant = function (tileData) {
    if (!tileData || !this.isVariantPurchasable(tileData) || !tileData.preview_image) return false;
    if (this.getSelectedCharmCount() >= this.getPoolMax()) return false;
    if (this.hasSlotGroups() && this.getNextAddIndex() === -1) return false;

    var selectedCount = countCharmsForVariant(this.selectedCharms, tileData.id);
    var stockCap = this.getVariantStockCap(tileData);

    if (stockCap !== null && selectedCount >= stockCap) return false;

    return true;
  };

  ProductBuilder.prototype.loadCartVariantCounts = function () {
    var self = this;

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var counts = {};
        (cart.items || []).forEach(function (item) {
          var id = String(item.variant_id);
          counts[id] = (counts[id] || 0) + item.quantity;
        });
        self.cartVariantCounts = counts;
      })
      .catch(function () {
        self.cartVariantCounts = {};
      });
  };

  ProductBuilder.prototype.refreshCharmCatalog = function () {
    var self = this;
    return this.loadCartVariantCounts().then(function () {
      return self.enrichCharmStock();
    });
  };

  ProductBuilder.prototype.getPoolMin = function () {
    var pool = this.data.pool || {};
    var sources = [pool.min_charms, this.config.min_charms, this.charmGroup && this.charmGroup.min];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 1;
  };

  ProductBuilder.prototype.getPoolMax = function () {
    var pool = this.data.pool || {};
    var sources = [pool.max_charms, this.config.max_charms, this.charmGroup && this.charmGroup.max];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 5;
  };

  ProductBuilder.prototype.getGridColumns = function () {
    var pool = this.data.pool || {};
    var sources = [pool.grid_columns, this.config.grid_columns, this.charmGroup && this.charmGroup.grid_columns];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 6;
  };

  ProductBuilder.prototype.getCharmTileLabel = function (tileData) {
    if (!tileData) return '';
    var label = '';
    if (tileData.type === 'letter') {
      label = String(tileData.letter || tileData.label || tileData.title || '').trim();
    } else {
      label = String(tileData.label || tileData.letter || tileData.design_token || tileData.title || '').trim();
    }
    return label.replace(/\s+Pendant\s*$/i, '');
  };

  ProductBuilder.prototype.getPanelTitle = function () {
    if (this.config.panel_title) return this.config.panel_title;
    if (this.charmGroup && this.charmGroup.label) return this.charmGroup.label;
    return 'Choose Your Charms';
  };

  ProductBuilder.prototype.hasCharmCatalog = function () {
    return this.charmTiles.length > 0 || this.charmGroups.length > 0;
  };

  ProductBuilder.prototype.charmGroupsHaveVariants = function () {
    if (!this.charmGroups.length) return false;

    for (var i = 0; i < this.charmGroups.length; i++) {
      var group = this.charmGroups[i];
      var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

      if (groupType === 'products' && group.products && group.products.length) {
        for (var j = 0; j < group.products.length; j++) {
          if ((group.products[j].variants || []).length) return true;
        }
      } else if ((group.variants || []).length) {
        return true;
      }
    }

    return false;
  };

  ProductBuilder.prototype.normalizeCharmGroups = function () {
    if (this.charmGroupsHaveVariants()) return;

    var configCharms = this.config.charms;
    if (!configCharms || !configCharms.length) {
      console.warn('[ProductBuilder] No charms defined in config');
      return;
    }

    this.charmGroups = configCharms.map(function (group, index) {
      var hasProducts = group.products && group.products.length;
      var type = group.type || (hasProducts ? 'products' : 'letter');
      var normalized = {
        id: group.id || group.product_handle || ('group-' + (index + 1)),
        type: type,
        label: group.label || 'Choose your charms',
        product_handle: group.product_handle || null,
        product_title: null,
        size_percent: group.size_percent != null ? group.size_percent : null,
        variants: []
      };

      if (type === 'products' && hasProducts) {
        normalized.products = group.products.map(function (entry) {
          if (typeof entry === 'string') {
            return {
              product_handle: entry,
              label: '',
              design_token: '',
              product_title: null,
              variants: []
            };
          }

          return {
            product_handle: entry.product_handle,
            label: entry.label || '',
            design_token: entry.design_token || '',
            preview_image: entry.preview_image || '',
            preview_image_blank: entry.preview_image_blank || '',
            product_title: entry.product_title || null,
            size_percent: entry.size_percent != null ? entry.size_percent : null,
            engraving: entry.engraving || null,
            gallery_images: entry.gallery_images || [],
            variants: entry.variants || []
          };
        });
      }

      return normalized;
    });

    this.charmGroup = this.charmGroups[0] || null;
  };

  ProductBuilder.prototype.getCharmPreviewImageWidth = function () {
    var preview = this.config.preview || {};
    if (preview.charm_image_width == null || preview.charm_image_width === '') {
      return null;
    }

    var width = parseInt(String(preview.charm_image_width), 10);
    if (isNaN(width) || width <= 0) return null;
    return width;
  };

  ProductBuilder.prototype.resolveCharmPreviewImageUrl = function (url) {
    if (!url) return '';

    var width = this.getCharmPreviewImageWidth();
    if (width == null) return url;

    if (/([?&])width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=' + width);
    }

    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + width;
  };

  ProductBuilder.prototype.getCharmShadowConfig = function () {
    var preview = this.config.preview || {};
    return preview.charm_shadow != null ? preview.charm_shadow : null;
  };

  ProductBuilder.prototype.formatCharmShadowColor = function (color, opacity) {
    if (!color) return 'rgba(178, 158, 143, 1)';

    var colorStr = String(color).trim();
    if (/^rgba?\(/i.test(colorStr) || /^hsla?\(/i.test(colorStr)) {
      return colorStr;
    }

    if (colorStr.charAt(0) === '#') {
      return colorStr;
    }

    var alpha = opacity == null ? 1 : Number(opacity);
    if (isNaN(alpha)) alpha = 1;
    return 'rgba(' + colorStr + ', ' + alpha + ')';
  };

  ProductBuilder.prototype.getCharmShadowFilter = function () {
    var shadow = this.getCharmShadowConfig();

    if (shadow === false || shadow === 'none') {
      return 'none';
    }

    if (typeof shadow === 'string') {
      var trimmed = shadow.trim();
      return trimmed ? trimmed : null;
    }

    if (!shadow || typeof shadow !== 'object') {
      return null;
    }

    if (shadow.enabled === false) {
      return 'none';
    }

    var x = shadow.x != null ? shadow.x : shadow.offset_x;
    var y = shadow.y != null ? shadow.y : shadow.offset_y;
    var blur = shadow.blur != null ? shadow.blur : shadow.blur_radius;
    var color = this.formatCharmShadowColor(shadow.color, shadow.opacity);

    x = x == null || x === '' ? 3 : Number(x);
    y = y == null || y === '' ? 2 : Number(y);
    blur = blur == null || blur === '' ? 1 : Number(blur);

    if (isNaN(x)) x = 3;
    if (isNaN(y)) y = 2;
    if (isNaN(blur)) blur = 1;

    return x + 'px ' + y + 'px ' + blur + 'px ' + color;
  };

  ProductBuilder.PREVIEW_MOBILE_QUERY = '(max-width: 900px)';

  ProductBuilder.prototype.isPreviewMobileViewport = function () {
    return window.matchMedia(ProductBuilder.PREVIEW_MOBILE_QUERY).matches;
  };

  ProductBuilder.prototype.getPreviewCanvasAspectRatio = function () {
    var preview = this.config.preview || {};
    var value = preview.canvas_aspect_ratio;

    if (value != null && String(value).trim() !== '') {
      return String(value).trim();
    }

    if (this.hasSlotGroups()) return '3 / 4';

    return null;
  };

  ProductBuilder.prototype.getPreviewColBackground = function () {
    var preview = this.config.preview || {};
    var value = preview.background_color || preview.preview_col_background;
    if (!value) return '';

    var hex = String(value).trim();
    if (/^#[0-9a-fA-F]{3}$/.test(hex) || /^#[0-9a-fA-F]{6}$/.test(hex)) {
      return hex;
    }
    if (/^[0-9a-fA-F]{3}$/.test(hex) || /^[0-9a-fA-F]{6}$/.test(hex)) {
      return '#' + hex;
    }

    return '';
  };

  ProductBuilder.prototype.applyPreviewAppearance = function () {
    var layer = this.els.charmsLayer;
    var baseImage = this.els.baseImage;
    var canvas = this.root.querySelector('[data-builder-canvas]');
    var position = this.getPreviewImagePosition();
    var topAligned = this.isPreviewTopAligned();
    var portrait = topAligned && !!this.getPreviewCanvasAspectRatio();
    var transform = this.getPreviewImageTransform();

    this.root.classList.toggle('product-builder--preview-top', topAligned);
    this.root.classList.toggle('product-builder--preview-portrait', portrait);

    if (this.els.previewCol) {
      var previewBackground = this.getPreviewColBackground();
      if (previewBackground) {
        this.els.previewCol.style.backgroundColor = previewBackground;
      } else {
        this.els.previewCol.style.removeProperty('background-color');
      }
    }

    if (layer) {
      var shadow = this.getCharmShadowFilter();

      if (shadow === 'none') {
        layer.style.filter = 'none';
      } else if (shadow) {
        layer.style.filter = 'drop-shadow(' + shadow + ')';
      } else {
        layer.style.removeProperty('filter');
      }
    }

    if (baseImage) {
      baseImage.style.objectPosition = position;
    }

    if (canvas) {
      canvas.classList.toggle('product-builder__canvas--align-top', topAligned);

      if (portrait) {
        canvas.style.setProperty('--preview-aspect-ratio', this.getPreviewCanvasAspectRatio());
      } else {
        canvas.style.removeProperty('--preview-aspect-ratio');
      }

      if (transform.offsetY || transform.scale !== 1) {
        canvas.classList.add('product-builder__canvas--preview-transform');
        canvas.style.setProperty('--preview-image-scale', String(transform.scale));
        canvas.style.setProperty('--preview-image-offset-y', transform.offsetY + '%');
      } else {
        canvas.classList.remove('product-builder__canvas--preview-transform');
        canvas.style.removeProperty('--preview-image-scale');
        canvas.style.removeProperty('--preview-image-offset-y');
      }
    }

    if (layer) {
      layer.style.removeProperty('transform');
      layer.style.removeProperty('transform-origin');
    }

    if (baseImage) {
      baseImage.style.removeProperty('transform');
      baseImage.style.removeProperty('transform-origin');
    }
  };

  ProductBuilder.prototype.isPreviewTopAligned = function () {
    return /^top/i.test(this.getPreviewImagePosition());
  };

  ProductBuilder.prototype.getMaxSlotYPercent = function () {
    var maxY = 0;
    var placement = this.placement || {};
    var sources = [placement.slot_sets];

    (placement.slot_groups || []).forEach(function (group) {
      sources.push(group.slot_sets);
    });

    sources.forEach(function (slotSets) {
      if (!slotSets) return;
      Object.keys(slotSets).forEach(function (key) {
        (slotSets[key] || []).forEach(function (slot) {
          var y = parseFloat(slot && slot.y_percent);
          if (!isNaN(y) && y > maxY) maxY = y;
        });
      });
    });

    return maxY || 76;
  };

  ProductBuilder.prototype.getPreviewImageTransform = function () {
    var preview = this.config.preview || {};
    var isMobile = this.isPreviewMobileViewport();
    var offsetSource = isMobile && preview.image_offset_y_percent_mobile != null
      ? preview.image_offset_y_percent_mobile
      : preview.image_offset_y_percent;
    var scaleSource = isMobile && preview.image_scale_mobile != null
      ? preview.image_scale_mobile
      : preview.image_scale;
    var offsetY = parseFloat(offsetSource);
    var scale = parseFloat(scaleSource);

    if (isNaN(offsetY)) offsetY = 0;
    if (isNaN(scale) || scale <= 0) scale = 1;

    // Keep bottom hoop charms inside the canvas when using top-origin scale.
    if (this.isPreviewTopAligned()) {
      var slotCap = 96 / this.getMaxSlotYPercent();
      scale = Math.min(scale, slotCap);
    }

    return {
      offsetY: offsetY,
      scale: scale
    };
  };

  ProductBuilder.prototype.getPreviewImagePosition = function () {
    var preview = this.config.preview || {};
    var value = preview.image_position || preview.object_position;

    if (typeof value === 'string') {
      var normalized = value.trim().toLowerCase();
      if (normalized === 'top' || normalized === 'top center') return 'top center';
      if (normalized === 'center' || normalized === 'center center') return 'center center';
      if (normalized === 'bottom' || normalized === 'bottom center') return 'bottom center';
      if (value.trim()) return value.trim();
    }

    // Necklaces with hoop groups: pin preview to top of canvas (bracelets stay centred).
    if (this.hasSlotGroups()) return 'top center';

    return 'center center';
  };

  ProductBuilder.prototype.getVariantPreviewImage = function (variant, product) {
    var url = '';

    if (variant && variant.featured_image) {
      url = variant.featured_image.src || variant.featured_image;
    } else if (product && product.featured_image) {
      url = product.featured_image.src || product.featured_image;
    } else if (product && product.images && product.images.length) {
      url = product.images[0].src || product.images[0];
    }

    return this.resolveCharmPreviewImageUrl(url);
  };

  ProductBuilder.prototype.resolveCharmProductVariant = function (product, entry) {
    var variants = (product && product.variants) || [];
    if (!variants.length) return null;

    entry = entry || {};

    if (entry.variant_id != null) {
      var byId = variants.find(function (variant) {
        return Number(variant.id) === Number(entry.variant_id);
      });
      if (byId) return byId;
    }

    if (entry.variant_title) {
      var titleNeedle = String(entry.variant_title).trim().toLowerCase();
      var byTitle = variants.find(function (variant) {
        return String(variant.title || '').toLowerCase().indexOf(titleNeedle) !== -1;
      });
      if (byTitle) return byTitle;
    }

    var noChain = variants.find(function (variant) {
      return String(variant.title || '').toLowerCase().indexOf('no chain') !== -1;
    });
    if (noChain) return noChain;

    var purchasable = variants.find(function (variant) {
      return this.isVariantPurchasable(variant);
    }, this);
    if (purchasable) return purchasable;

    return variants[0];
  };

  ProductBuilder.prototype.buildCharmProductVariantEntry = function (product, entry) {
    var preferredVariant = this.resolveCharmProductVariant(product, entry);
    if (!preferredVariant) return null;

    var label = entry.label || product.title;
    var previewImage = entry.preview_image || this.getVariantPreviewImage(preferredVariant, product);
    var variantEntry = {
      id: preferredVariant.id,
      letter: label,
      title: preferredVariant.title,
      price: preferredVariant.price,
      available: preferredVariant.available,
      inventory_quantity: preferredVariant.inventory_quantity != null
        ? preferredVariant.inventory_quantity
        : null,
      inventory_management: preferredVariant.inventory_management || null,
      inventory_policy: preferredVariant.inventory_policy || 'deny',
      preview_image: previewImage,
      sku: preferredVariant.sku,
      design_token: entry.design_token || label
    };

    this.syncVariantInventory(variantEntry, preferredVariant);
    return variantEntry;
  };

  ProductBuilder.prototype.buildCharmTiles = function () {
    var self = this;
    var tiles = [];

    this.charmGroups.forEach(function (group) {
      var groupId = group.id || group.product_handle || 'group';
      var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

      if (groupType === 'products' && group.products && group.products.length) {
        group.products.forEach(function (product) {
          var tileSizePercent = product.size_percent != null
            ? product.size_percent
            : self.getConfigCharmSizePercent(product.product_handle, groupId);

          (product.variants || []).forEach(function (variant) {
            var label = product.label || product.product_title || variant.letter || variant.title;
            var previewImage = product.preview_image || variant.preview_image || '';
            var tile = {
              groupId: groupId,
              type: 'product',
              product_handle: product.product_handle,
              product_title: product.product_title,
              label: label,
              design_token: variant.design_token || product.design_token || label,
              id: variant.id,
              letter: label,
              title: variant.title,
              price: variant.price,
              preview_image: previewImage,
              preview_image_blank: product.preview_image_blank || '',
              sku: variant.sku,
              available: variant.available,
              inventory_quantity: variant.inventory_quantity,
              inventory_management: variant.inventory_management,
              inventory_policy: variant.inventory_policy,
              engraving: product.engraving || null,
              gallery_images: product.gallery_images || []
            };

            if (tileSizePercent != null) {
              tile.size_percent = tileSizePercent;
            }

            tiles.push(tile);
          });
        });
        return;
      }

      var letterSizePercent = group.size_percent != null
        ? group.size_percent
        : self.getConfigCharmSizePercent(group.product_handle, groupId);

      (group.variants || []).forEach(function (variant) {
        var tile = {
          groupId: groupId,
          type: 'letter',
          product_handle: group.product_handle,
          product_title: group.product_title,
          label: variant.letter || variant.title,
          design_token: variant.design_token || variant.letter || variant.title,
          id: variant.id,
          letter: variant.letter || variant.title,
          title: variant.title,
          price: variant.price,
          preview_image: variant.preview_image,
          sku: variant.sku,
          available: variant.available,
          inventory_quantity: variant.inventory_quantity,
          inventory_management: variant.inventory_management,
          inventory_policy: variant.inventory_policy
        };

        if (letterSizePercent != null) {
          tile.size_percent = letterSizePercent;
        }

        tiles.push(tile);
      });
    });

    return tiles;
  };

  ProductBuilder.prototype.syncCharmTiles = function () {
    this.charmTiles = this.buildCharmTiles();
  };

  ProductBuilder.prototype.getCharmDisplayToken = function (charm) {
    if (!charm) return '';

    if (charm.charmType === 'letter') {
      return normalizeDesignToken(charm.letter);
    }

    var label = normalizeDesignToken(charm.label || charm.letter);
    if (charm.engraving && charm.engraving.enabled && charm.engraving.letters) {
      return label + ' ' + normalizeDesignToken(charm.engraving.letters);
    }

    return label;
  };

  ProductBuilder.prototype.getCharmEngravingConfig = function (tileData) {
    if (!tileData) return null;

    if (tileData.engraving && tileData.engraving.enabled) {
      return tileData.engraving;
    }

    var handle = tileData.product_handle;
    if (!handle) return null;

    var groups = this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        if (entry.product_handle === handle && entry.engraving && entry.engraving.enabled) {
          return entry.engraving;
        }
      }
    }

    return null;
  };

  ProductBuilder.prototype.resolveBlankPreviewImage = function (product, entry) {
    var engraving = entry && entry.engraving;

    if (engraving && engraving.preview_image_blank) {
      return String(engraving.preview_image_blank);
    }

    if (entry && entry.preview_image_blank) {
      return String(entry.preview_image_blank);
    }

    var blankFromAlt = '';
    (product.images || []).forEach(function (image) {
      if (blankFromAlt) return;

      var alt = String(image.alt || '').toLowerCase();
      if (alt.indexOf('blank') !== -1
        || alt.indexOf('no engraving') !== -1
        || alt.indexOf('unengraved') !== -1) {
        blankFromAlt = image.src || image;
      }
    });

    return blankFromAlt;
  };

  ProductBuilder.prototype.getCharmBlankPreviewImage = function (tileData) {
    if (!tileData) return '';

    var config = this.getCharmEngravingConfig(tileData) || {};
    if (config.preview_image_blank) {
      return String(config.preview_image_blank);
    }

    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    if (liveTile.preview_image_blank) {
      return String(liveTile.preview_image_blank);
    }

    var handle = tileData.product_handle;
    if (!handle) return '';

    var groups = this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        if (entry.product_handle !== handle) continue;

        if (entry.preview_image_blank) {
          return String(entry.preview_image_blank);
        }

        if (entry.engraving && entry.engraving.preview_image_blank) {
          return String(entry.engraving.preview_image_blank);
        }

        return '';
      }
    }

    return '';
  };

  ProductBuilder.prototype.resolveEngraveGalleryImages = function (engraving, entry, product) {
    engraving = engraving || {};

    if (engraving.gallery === false) {
      return [];
    }

    if (engraving.gallery_images != null) {
      if (!Array.isArray(engraving.gallery_images)) {
        return [];
      }

      return engraving.gallery_images.map(function (url) {
        return String(url);
      }).filter(Boolean);
    }

    var images = (product && product.images ? product.images : []).map(function (image) {
      return image.src || image;
    }).filter(Boolean);

    if (images.length) {
      return images;
    }

    if (entry && entry.gallery_images && entry.gallery_images.length) {
      return entry.gallery_images.map(function (url) {
        return String(url);
      });
    }

    return [];
  };

  ProductBuilder.prototype.getProductGalleryImages = function (product, entry) {
    return this.resolveEngraveGalleryImages(entry && entry.engraving, entry, product);
  };

  ProductBuilder.prototype.getCharmEngravingGalleryImages = function (tileData, config) {
    var engraving = config || this.getCharmEngravingConfig(tileData) || {};

    if (engraving.gallery === false) {
      return [];
    }

    if (engraving.gallery_images != null) {
      if (!Array.isArray(engraving.gallery_images)) {
        return [];
      }

      return engraving.gallery_images.map(function (url) {
        return String(url);
      }).filter(Boolean);
    }

    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    if (liveTile.gallery_images && liveTile.gallery_images.length) {
      return liveTile.gallery_images.map(function (url) {
        return String(url);
      });
    }

    var handle = tileData.product_handle;
    if (!handle) return [];

    var groups = this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        if (entry.product_handle !== handle) continue;

        return this.resolveEngraveGalleryImages(entry.engraving, entry, null);
      }
    }

    return [];
  };

  ProductBuilder.prototype.destroyEngraveGallerySlider = function () {
    var track = this.els.engraveGalleryTrack;
    if (!track || typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) return;

    var $track = jQuery(track);
    if ($track.hasClass('slick-initialized')) {
      $track.slick('unslick');
    }
  };

  ProductBuilder.prototype.getEngraveGalleryCenterPadding = function () {
    var track = this.els.engraveGalleryTrack;
    if (!track) return '1.5rem';

    var inner = track.closest('.product-builder__engrave-tray-inner');
    if (!inner) return '1.5rem';

    var sidePadding = parseFloat(window.getComputedStyle(inner).paddingLeft);
    if (isNaN(sidePadding) || sidePadding <= 0) {
      return '1.5rem';
    }

    return sidePadding + 'px';
  };

  ProductBuilder.prototype.isEngraveGalleryEnabled = function () {
    return window.matchMedia('(min-width: 901px)').matches;
  };

  ProductBuilder.prototype.syncEngraveGalleryLayout = function () {
    if (!this.isEngraveGalleryEnabled()) return;

    var gallery = this.els.engraveGallery;
    var inner = this.els.engraveTray
      ? this.els.engraveTray.querySelector('.product-builder__engrave-tray-inner')
      : null;

    if (!gallery || gallery.hidden || !inner) return;

    gallery.style.removeProperty('--engrave-slide-max-height');

    var track = this.els.engraveGalleryTrack;
    if (track) {
      track.style.height = '';
    }

    var reserved = 0;
    var childNodes = inner.children;

    for (var i = 0; i < childNodes.length; i++) {
      var child = childNodes[i];
      if (child === gallery || child.hidden) continue;

      var childStyle = window.getComputedStyle(child);
      if (childStyle.display === 'none') continue;

      reserved += child.offsetHeight;
      reserved += parseFloat(childStyle.marginTop) || 0;
      reserved += parseFloat(childStyle.marginBottom) || 0;
    }

    var innerStyle = window.getComputedStyle(inner);
    reserved += parseFloat(innerStyle.paddingTop) || 0;
    reserved += parseFloat(innerStyle.paddingBottom) || 0;

    var galleryStyle = window.getComputedStyle(gallery);
    reserved += parseFloat(galleryStyle.marginTop) || 0;
    reserved += parseFloat(galleryStyle.marginBottom) || 0;

    var dots = track ? track.querySelector('.slick-dots') : null;
    if (dots) {
      var dotsStyle = window.getComputedStyle(dots);
      reserved += dots.offsetHeight
        + (parseFloat(dotsStyle.marginTop) || 0)
        + (parseFloat(dotsStyle.marginBottom) || 0);
    }

    var innerHeight = inner.clientHeight || window.innerHeight;
    var maxSlideHeight = Math.max(120, innerHeight - reserved);

    gallery.style.setProperty('--engrave-slide-max-height', maxSlideHeight + 'px');

    if (track && typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick) {
      var $track = jQuery(track);
      if ($track.hasClass('slick-initialized')) {
        $track.slick('setPosition');
      }
    }
  };

  ProductBuilder.prototype.initEngraveGallerySlider = function (slideCount) {
    var track = this.els.engraveGalleryTrack;
    if (!track || typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) return;

    this.destroyEngraveGallerySlider();

    var $track = jQuery(track);
    $track.slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: slideCount > 1,
      draggable: true,
      swipe: true,
      swipeToSlide: true,
      infinite: false,
      adaptiveHeight: false,
      touchMove: true,
      centerMode: slideCount > 1,
      centerPadding: this.getEngraveGalleryCenterPadding(),
      focusOnSelect: false
    });

    var self = this;
    requestAnimationFrame(function () {
      self.syncEngraveGalleryLayout();
      requestAnimationFrame(function () {
        if ($track.hasClass('slick-initialized')) {
          $track.slick('setPosition');
        }
      });
    });
  };

  ProductBuilder.prototype.renderEngraveGallery = function (tileData, config) {
    if (!this.els.engraveGallery || !this.els.engraveGalleryTrack) return;

    this.destroyEngraveGallerySlider();
    this.els.engraveGalleryTrack.innerHTML = '';

    if (!this.isEngraveGalleryEnabled()) {
      this.els.engraveGallery.hidden = true;
      return;
    }

    var images = this.getCharmEngravingGalleryImages(tileData, config || {});

    if (!images.length) {
      this.els.engraveGallery.hidden = true;
      return;
    }

    var label = tileData.label || tileData.product_title || 'Engraving example';
    images.forEach(function (url, index) {
      var slide = document.createElement('div');
      slide.className = 'product-builder__engrave-gallery-slide';

      var img = configureBuilderImage(document.createElement('img'));
      img.src = url;
      img.alt = label + ' example ' + (index + 1);
      img.loading = index === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);
      this.els.engraveGalleryTrack.appendChild(slide);
    }, this);

    this.els.engraveGallery.hidden = false;
    this.initEngraveGallerySlider(images.length);

    var self = this;
    images.forEach(function (url, index) {
      var img = self.els.engraveGalleryTrack
        && self.els.engraveGalleryTrack.querySelectorAll('.product-builder__engrave-gallery-slide img')[index];
      if (img && !img.complete) {
        img.addEventListener('load', function () {
          self.syncEngraveGalleryLayout();
        }, { once: true });
      }
    });
  };

  ProductBuilder.prototype.normalizeEngravingLetters = function (value, maxLetters) {
    var letters = String(value || '')
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .slice(0, maxLetters);

    return letters;
  };

  ProductBuilder.prototype.getCharmReviewSubtitle = function (charm) {
    if (!charm) return '';

    if (charm.engraving && charm.engraving.enabled && charm.engraving.letters) {
      return 'Engraving: ' + charm.engraving.letters;
    }

    return charm.letter || charm.label || '';
  };

  ProductBuilder.prototype.buildCharmDataFromTile = function (tileData, engravingState) {
    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    var previewImage = liveTile.preview_image;

    if (!engravingState) {
      var blankPreview = this.getCharmBlankPreviewImage(liveTile);
      if (blankPreview) {
        previewImage = blankPreview;
      }
    }

    return {
      instanceId: generateBuilderId(),
      id: liveTile.id,
      groupId: liveTile.groupId,
      charmType: liveTile.type || 'letter',
      product_handle: liveTile.product_handle,
      product_title: liveTile.product_title,
      letter: liveTile.letter || liveTile.title,
      label: liveTile.label || liveTile.letter || liveTile.title,
      design_token: liveTile.design_token || liveTile.letter || liveTile.title,
      title: liveTile.title,
      price: liveTile.price,
      preview_image: previewImage,
      sku: liveTile.sku,
      size_percent: liveTile.size_percent != null ? liveTile.size_percent : null,
      engraving: engravingState || null
    };
  };

  ProductBuilder.prototype.addCharmToSelection = function (charmData) {
    if (this.hasSlotGroups()) {
      var slotIndex = this.getNextAddIndex();
      if (slotIndex === -1) return false;
      this.ensureSlotStorage();
      this.selectedCharms[slotIndex] = charmData;
    } else {
      this.selectedCharms.push(charmData);
    }

    this.renderCharmGrid();
    this.renderPreview();
    this.updateEditButtonVisibility();

    if (this.getSelectedCharmCount() >= this.getMinCharms()) {
      this.clearCharmValidation();
    }

    if (this.step === 'edit') {
      this.renderSelectedCharmsTray();
    }

    return true;
  };

  ProductBuilder.prototype.showEngraveError = function (message) {
    if (!this.els.engraveError) return;
    if (message) {
      this.els.engraveError.textContent = message;
      this.els.engraveError.hidden = false;
    } else {
      this.els.engraveError.hidden = true;
      this.els.engraveError.textContent = '';
    }
  };

  ProductBuilder.prototype.closeCharmEngravingPanel = function () {
    this.pendingEngraveTile = null;
    this.showEngraveError('');
    if (this.els.engraveInput) {
      this.els.engraveInput.value = '';
    }
    if (this.els.engraveGallery) {
      this.els.engraveGallery.hidden = true;
      this.els.engraveGallery.style.removeProperty('--engrave-slide-max-height');
    }
    if (this.els.engraveGalleryTrack) {
      this.destroyEngraveGallerySlider();
      this.els.engraveGalleryTrack.innerHTML = '';
      this.els.engraveGalleryTrack.style.height = '';
    }
    if (this.root) {
      this.root.classList.remove('product-builder--engraving-open');
    }
  };

  ProductBuilder.prototype.renderEngraveNotes = function (config) {
    if (!this.els.engraveNotes) return;

    var notes = config && config.things_to_know;
    if (notes === false) {
      this.els.engraveNotes.hidden = true;
      return;
    }

    var title = (notes && notes.title) || 'Things to know:';
    var items = (notes && notes.items) || [
      'Hand engraved and delivered within 2-3 weeks',
      'Personalised products can\'t be returned or refunded.'
    ];

    if (!items || !items.length) {
      this.els.engraveNotes.hidden = true;
      return;
    }

    if (this.els.engraveNotesTitle) {
      this.els.engraveNotesTitle.textContent = title;
    }

    if (this.els.engraveNotesList) {
      this.els.engraveNotesList.innerHTML = '';
      var self = this;
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        self.els.engraveNotesList.appendChild(li);
      });
    }

    this.els.engraveNotes.hidden = false;
  };

  ProductBuilder.prototype.openCharmEngravingPanel = function (tileData) {
    var config = this.getCharmEngravingConfig(tileData);
    if (!config) return false;

    var maxLetters = parsePositiveInt(config.max_letters);
    if (maxLetters === null) maxLetters = 3;

    this.pendingEngraveTile = tileData;
    this.showEngraveError('');

    if (this.els.engraveTitle) {
      this.els.engraveTitle.textContent = config.title || 'Hand Engraving';
    }

    if (this.els.engraveHint) {
      var hintParts = [];

      if (config.hint) {
        hintParts.push(config.hint);
      }

      if (config.preview_note && config.preview_note !== false) {
        hintParts.push(String(config.preview_note));
      }

      if (hintParts.length) {
        this.els.engraveHint.textContent = hintParts.join(' ');
        this.els.engraveHint.hidden = false;
      } else {
        this.els.engraveHint.textContent = '';
        this.els.engraveHint.hidden = true;
      }
    }

    if (this.els.engraveMax) {
      this.els.engraveMax.textContent = config.max_label
        || ('Max. ' + maxLetters + ' character' + (maxLetters === 1 ? '' : 's'));
    }

    if (this.els.engraveLabel) {
      var fieldLabel = config.input_label || 'Enter letters here';
      this.els.engraveLabel.textContent = fieldLabel;
    }

    if (this.els.engraveInput) {
      this.els.engraveInput.value = '';
      this.els.engraveInput.maxLength = maxLetters;
      this.els.engraveInput.placeholder = config.placeholder || config.input_label || 'Enter letters here';
    }

    if (this.els.engraveSkip) {
      this.els.engraveSkip.hidden = config.allow_skip === false;
      this.els.engraveSkip.textContent = config.skip_label || 'No engraving';
    }

    if (this.els.engraveConfirm) {
      this.els.engraveConfirm.textContent = config.confirm_label || 'Add charm';
    }

    this.renderEngraveNotes(config);

    if (this.root) {
      this.root.classList.add('product-builder--engraving-open');
    }

    this.renderEngraveGallery(tileData, config);
    this.syncEngraveGalleryLayout();

    if (this.els.engraveInput) {
      this.els.engraveInput.focus();
    }

    return true;
  };

  ProductBuilder.prototype.confirmCharmEngraving = function (withEngraving) {
    if (!this.pendingEngraveTile) return;

    var tileData = this.pendingEngraveTile;
    var config = this.getCharmEngravingConfig(tileData) || {};
    var maxLetters = parsePositiveInt(config.max_letters);
    if (maxLetters === null) maxLetters = 3;

    var engravingState = null;

    if (withEngraving) {
      var letters = this.normalizeEngravingLetters(
        this.els.engraveInput ? this.els.engraveInput.value : '',
        maxLetters
      );

      if (!letters.length) {
        this.showEngraveError('Please enter at least 1 letter.');
        return;
      }

      engravingState = {
        enabled: true,
        letters: letters,
        option: 'Letters'
      };
    }

    var charmData = this.buildCharmDataFromTile(tileData, engravingState);
    if (!this.canAddCharmVariant(tileData)) {
      this.showEngraveError('This charm is no longer available.');
      return;
    }

    this.closeCharmEngravingPanel();
    this.addCharmToSelection(charmData);
  };

  ProductBuilder.prototype.getSlotPositionInGroup = function (slotIndex) {
    var group = this.getSlotGroupForIndex(slotIndex);
    if (!group) return 0;

    var order = this.getSlotFillOrder(group);
    var position = order.indexOf(slotIndex);
    return position === -1 ? 0 : position + 1;
  };

  ProductBuilder.prototype.getSlotPlacementLabel = function (slotIndex) {
    var group = this.getSlotGroupForIndex(slotIndex);
    if (!group) return '';

    var groupLabel = (group.label || group.id || 'Hoop').trim();
    if (this.countCharmsInGroup(group) <= 1) {
      return groupLabel;
    }

    var position = this.getSlotPositionInGroup(slotIndex);
    return groupLabel + ' · ' + position;
  };

  ProductBuilder.prototype.getDesignLabel = function () {
    if (!this.hasSlotGroups()) {
      return this.getSelectedCharmsList().map(function (c) {
        return normalizeDesignToken(c.design_token || c.letter);
      }).join('');
    }

    var entries = [];
    this.forEachSelectedCharm(function (charm, slotIndex) {
      entries.push({
        token: this.getCharmDisplayToken(charm),
        placement: this.getSlotPlacementLabel(slotIndex)
      });
    }, this);

    if (typeof theme !== 'undefined' && typeof theme.formatBuilderSlotDesign === 'function') {
      return theme.formatBuilderSlotDesign(entries);
    }

    return entries.map(function (entry) {
      return entry.token + ' (' + entry.placement + ')';
    }).join(' · ');
  };

  ProductBuilder.prototype.getComplementaryCharmCount = function () {
    var pool = this.data.pool || {};
    var sources = [
      pool.complementary_charms,
      this.config.complementary_charms,
      this.config.complementary_included,
      this.charmGroup && this.charmGroup.complementary_included,
      this.charmGroup && this.charmGroup.complementary_charms
    ];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 0;
  };

  ProductBuilder.prototype.getComplementaryLabel = function () {
    return (this.config.complementary_label || 'Complimentary').trim();
  };

  ProductBuilder.prototype.getBespokeCharmsConfig = function () {
    var cfg = this.config && this.config.bespoke_charms;
    if (!cfg || cfg.enabled !== true) return null;
    return cfg;
  };

  ProductBuilder.prototype.getBespokeCharmsPrompt = function () {
    var cfg = this.getBespokeCharmsConfig();
    if (!cfg) return '';

    if (cfg.prompt) return String(cfg.prompt).trim();

    return 'Need more than ' + this.getPoolMax() + ' charms?';
  };

  ProductBuilder.prototype.getBespokeCharmsMessageHtml = function () {
    var cfg = this.getBespokeCharmsConfig();
    if (!cfg || !cfg.message) return '';

    var message = String(cfg.message);
    var linkText = (cfg.concierge_text || 'concierge').trim();
    var linkUrl = (cfg.concierge_url || '/pages/otiumberg-concierge').trim();
    var parts = message.split(linkText);

    if (parts.length === 2 && linkText) {
      return parts[0] + '<a href="' + linkUrl + '" target="_blank" rel="noopener noreferrer">' + linkText + '</a>' + parts[1];
    }

    return message;
  };

  ProductBuilder.prototype.closeBespokeCharmsMessage = function () {
    if (!this.els.bespokeCharmsToggle || !this.els.bespokeCharmsMessage) return;

    this.els.bespokeCharmsToggle.setAttribute('aria-expanded', 'false');
    this.els.bespokeCharmsMessage.hidden = true;
  };

  ProductBuilder.prototype.updateBespokeCharmsNote = function () {
    if (!this.els.bespokeCharms || !this.els.bespokeCharmsToggle || !this.els.bespokeCharmsMessage) {
      return;
    }

    var cfg = this.getBespokeCharmsConfig();
    var atMax = this.getSelectedCharmCount() >= this.getPoolMax();
    var show = Boolean(cfg) && atMax && (this.step === 'choose' || this.step === 'edit');

    if (!show) {
      this.els.bespokeCharms.hidden = true;
      this.closeBespokeCharmsMessage();
      return;
    }

    this.els.bespokeCharmsToggle.textContent = this.getBespokeCharmsPrompt();
    this.els.bespokeCharmsMessage.innerHTML = this.getBespokeCharmsMessageHtml();
    this.els.bespokeCharms.hidden = false;
  };

  ProductBuilder.prototype.isComplementaryCharmIndex = function (index) {
    return index < this.getComplementaryCharmCount();
  };

  ProductBuilder.prototype.isNextCharmComplementary = function () {
    return this.getSelectedCharmCount() < this.getComplementaryCharmCount();
  };

  ProductBuilder.prototype.getTotalPrice = function () {
    var self = this;
    var base = this.getBaseVariant();
    var total = base ? Number(base.price) : 0;
    this.forEachSelectedCharm(function (charm, slotIndex, sequence) {
      if (!self.isComplementaryCharmIndex(sequence)) {
        total += Number(charm.price) || 0;
      }
    });
    return total;
  };

  ProductBuilder.prototype.setPageScrollLock = function (lock) {
    var html = document.documentElement;
    var body = document.body;

    if (lock) {
      if (this.scrollLockActive) return;

      this.scrollLockScrollY = window.scrollY || window.pageYOffset || 0;
      this.scrollbarGap = window.innerWidth - html.clientWidth;

      html.classList.add('product-builder-open');
      body.classList.add('product-builder-open');
      body.style.top = '-' + this.scrollLockScrollY + 'px';

      if (this.scrollbarGap > 0) {
        body.style.paddingRight = this.scrollbarGap + 'px';
      }

      this.scrollLockActive = true;
      return;
    }

    if (!this.scrollLockActive) return;

    html.classList.remove('product-builder-open');
    body.classList.remove('product-builder-open');
    body.style.top = '';
    body.style.paddingRight = '';
    window.scrollTo(0, this.scrollLockScrollY || 0);

    this.scrollLockActive = false;
    this.scrollLockScrollY = 0;
    this.scrollbarGap = 0;
  };

  ProductBuilder.PANEL_TRANSITION_MS = 680;
  ProductBuilder.PANEL_MOBILE_MAX_WIDTH = 900;

  ProductBuilder.prototype.shouldAnimatePanelStep = function () {
    return window.matchMedia(
      '(min-width: ' + (ProductBuilder.PANEL_MOBILE_MAX_WIDTH + 1) + 'px)'
    ).matches;
  };

  ProductBuilder.prototype.isPanelStepTransition = function (fromStep, toStep) {
    if (!this.shouldAnimatePanelStep()) return false;

    return (fromStep === 'choose' || fromStep === 'review') &&
      (toStep === 'choose' || toStep === 'review') &&
      fromStep !== toStep;
  };

  ProductBuilder.prototype.beginPanelStepTransition = function (toStep) {
    var stack = this.els.panelStack;
    if (!stack) return;

    var currentHeight = stack.offsetHeight;
    var incomingPanel = toStep === 'review' ? this.els.panelReview : this.els.panelChoose;
    var incomingHeight = incomingPanel ? incomingPanel.scrollHeight : 0;

    stack.style.setProperty(
      '--panel-stack-height',
      Math.max(currentHeight, incomingHeight) + 'px'
    );
    stack.classList.add('is-panel-transitioning');
  };

  ProductBuilder.prototype.endPanelStepTransition = function () {
    var stack = this.els.panelStack;
    if (!stack) return;

    stack.classList.remove('is-panel-transitioning');
    stack.style.removeProperty('--panel-stack-height');
  };

  ProductBuilder.prototype.setStep = function (step) {
    var isReview = step === 'review';
    var isEdit = step === 'edit';
    var isBuilder = step === 'choose' || step === 'review' || isEdit;
    var fromStep = this.step;
    var panelTransition = this.isPanelStepTransition(fromStep, step);

    if (this.root && this.root.classList.contains('product-builder--engraving-open')) {
      this.closeCharmEngravingPanel();
    }

    if (isReview) {
      this.renderReview();
      this.clearCharmValidation();
    }

    if (panelTransition) {
      this.beginPanelStepTransition(step);
      clearTimeout(this.panelTransitionTimer);
    }

    this.step = step;
    this.root.setAttribute('data-step', step);

    if (this.root) {
      this.root.hidden = !isBuilder;
    }
    this.setPageScrollLock(isBuilder);

    if (this.els.workspace) {
      this.els.workspace.hidden = !isBuilder;
    }

    if (this.els.panelChoose) {
      this.els.panelChoose.setAttribute('aria-hidden', isReview ? 'true' : 'false');
    }
    if (this.els.panelReview) {
      this.els.panelReview.setAttribute('aria-hidden', isReview ? 'false' : 'true');
    }
    if (this.els.reviewBtn) {
      this.els.reviewBtn.hidden = isReview;
    }
    if (this.els.addToBagBtn) {
      this.els.addToBagBtn.hidden = !isReview;
    }
    this.updateEditButtonVisibility();
    if (this.els.runningTotal) {
      this.els.runningTotal.hidden = !(step === 'choose' || step === 'review' || step === 'edit');
    }

    if (!isReview) {
      this.updateRunningTotal();
    }
    this.updateComplementaryNote();
    this.updateBespokeCharmsNote();
    this.updateEditHint();

    if (panelTransition) {
      var self = this;
      this.panelTransitionTimer = setTimeout(function () {
        self.endPanelStepTransition();
      }, ProductBuilder.PANEL_TRANSITION_MS);
    }
  };

  ProductBuilder.prototype.updateBasePreview = function () {
    var previewUrl = this.data.base.preview_image;
    var variant = this.getBaseVariant();
    if (variant && variant.featured_image) {
      previewUrl = variant.featured_image;
    }
    if (this.els.baseImage && previewUrl) {
      this.els.baseImage.src = previewUrl;
    }
  };

  ProductBuilder.prototype.renderCharmGrid = function () {
    var self = this;
    var grid = this.els.charmGrid;
    if (!grid || !this.hasCharmCatalog()) return;

    if (this.els.panelTitle) {
      this.els.panelTitle.textContent = this.getPanelTitle();
    }

    this.updateComplementaryNote();
    this.updateBespokeCharmsNote();

    grid.innerHTML = '';
    grid.style.gridTemplateColumns = 'repeat(' + this.getGridColumns() + ', minmax(0, 1fr))';

    var atMax = self.getSelectedCharmCount() >= self.getPoolMax();

    this.charmTiles.forEach(function (tileData) {
      var hasPreview = Boolean(tileData.preview_image);
      var isAvailable = self.isVariantPurchasable(tileData) && hasPreview;
      var selectedCount = countCharmsForVariant(self.selectedCharms, tileData.id);
      var stockCap = self.getVariantStockCap(tileData);
      var atStockCap = stockCap !== null && selectedCount >= stockCap;
      var tileLabel = self.getCharmTileLabel(tileData);

      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'product-builder__charm-tile';
      tile.dataset.variantId = tileData.id;
      tile.disabled = !isAvailable || atMax || atStockCap;

      if (!hasPreview) {
        tile.classList.add('is-unavailable');
      }
      if (selectedCount > 0) {
        tile.classList.add('is-selected');
      }

      var media = document.createElement('span');
      media.className = 'product-builder__charm-tile-media';

      if (tileData.preview_image) {
        var img = configureBuilderImage(document.createElement('img'));
        img.src = self.resolveCharmPreviewImageUrl(tileData.preview_image);
        img.alt = tileLabel;
        media.appendChild(img);
      } else {
        var letter = document.createElement('span');
        letter.className = 'product-builder__charm-tile-letter';
        letter.textContent = tileLabel;
        media.appendChild(letter);
      }

      if (selectedCount > 0) {
        var badge = document.createElement('span');
        badge.className = 'product-builder__charm-count';
        badge.textContent = String(selectedCount);
        media.appendChild(badge);
      }

      tile.appendChild(media);

      var label = document.createElement('span');
      label.className = 'product-builder__charm-tile-label';
      label.textContent = tileLabel;
      tile.appendChild(label);

      tile.addEventListener('click', function () {
        self.onCharmTileClick(tileData);
      });

      if (self.supportsHover) {
        tile.addEventListener('mouseenter', function (e) {
          if (!isAvailable) return;
          if (self.isNextCharmComplementary()) return;
          self.showPriceTooltip(e.currentTarget, tileData.price);
        });
        tile.addEventListener('mouseleave', function () {
          self.hidePriceTooltip();
        });
      }

      grid.appendChild(tile);
    });
  };

  ProductBuilder.prototype.showPriceTooltip = function (target, priceCents) {
    if (!this.els.priceTooltip) return;
    var rect = target.getBoundingClientRect();
    this.els.priceTooltip.textContent = '+' + formatMoney(priceCents, this.data.money_format);
    this.els.priceTooltip.hidden = false;
    this.els.priceTooltip.style.left = rect.left + rect.width / 2 + 'px';
    this.els.priceTooltip.style.top = rect.top + 'px';
  };

  ProductBuilder.prototype.hidePriceTooltip = function () {
    if (this.els.priceTooltip) {
      this.els.priceTooltip.hidden = true;
    }
  };

  ProductBuilder.prototype.onCharmTileClick = function (tileData) {
    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    if (!this.canAddCharmVariant(liveTile)) {
      var groupMsg = this.getGroupLimitMessage();
      if (groupMsg && this.getSelectedCharmCount() < this.getPoolMax()) {
        this.showCharmValidation(groupMsg);
      }
      return;
    }

    if (this.getCharmEngravingConfig(liveTile)) {
      this.openCharmEngravingPanel(liveTile);
      return;
    }

    this.addCharmToSelection(this.buildCharmDataFromTile(liveTile));
  };

  ProductBuilder.prototype.resetBuilderSelection = function () {
    this.selectedCharms = this.hasSlotGroups() ? this.createEmptySlotStorage() : [];
    this.builderId = null;
    this.previewCharmStates = {};
    this.renderSelectedCharmsTray();
    this.renderCharmGrid();
    this.renderPreview();
    this.updateEditButtonVisibility();
    this.clearCharmValidation();
  };

  ProductBuilder.prototype.startOver = function () {
    this.resetBuilderSelection();
    this.setStep('choose');
  };

  ProductBuilder.prototype.getMinCharms = function () {
    return this.getPoolMin();
  };

  ProductBuilder.prototype.getCharmValidationMessage = function () {
    var min = this.getMinCharms();
    if (this.getSelectedCharmCount() >= min) return '';
    return 'Please select at least ' + min + ' charm' + (min > 1 ? 's' : '') + '.';
  };

  ProductBuilder.prototype.showCharmValidation = function (message) {
    if (!this.els.charmValidation) return;
    if (message) {
      this.els.charmValidation.textContent = message;
      this.els.charmValidation.hidden = false;
    } else {
      this.els.charmValidation.hidden = true;
      this.els.charmValidation.textContent = '';
    }
  };

  ProductBuilder.prototype.clearCharmValidation = function () {
    this.showCharmValidation('');
  };

  ProductBuilder.prototype.validateMinCharms = function () {
    var message = this.getCharmValidationMessage();
    if (message) {
      this.showCharmValidation(message);
      return false;
    }
    this.clearCharmValidation();
    return true;
  };

  ProductBuilder.prototype.openEditDrawer = function () {
    if (!this.getSelectedCharmCount()) return;
    this.renderSelectedCharmsTray();
    this.setStep('edit');
  };

  ProductBuilder.prototype.updateCharmCounter = function () {
    var count = this.getSelectedCharmCount();
    var max = this.charmGroup ? (this.charmGroup.max || 5) : 5;

    if (this.els.charmCounterText) {
      this.els.charmCounterText.textContent = count + ' / ' + max;
    }

    if (this.els.editBtn) {
      this.els.editBtn.setAttribute(
        'aria-label',
        count === 0
          ? count + ' of ' + max + ' charms selected'
          : 'Edit or move ' + count + ' of ' + max + ' selected charms'
      );
    }
  };

  ProductBuilder.prototype.animateEditButtonIn = function () {
    var btn = this.els.editBtn;
    if (!btn || btn.hidden || btn.classList.contains('is-faded')) return;

    btn.classList.remove('is-entering');
    void btn.offsetWidth;
    btn.classList.add('is-entering');
  };

  ProductBuilder.prototype.updateEditButtonVisibility = function () {
    var hasCharms = this.getSelectedCharmCount() > 0;
    var isEdit = this.step === 'edit';
    var isReview = this.step === 'review';

    if (this.els.editBtn) {
      var shouldShow = hasCharms && !isReview;
      var wasHidden = this.els.editBtn.hidden;

      this.els.editBtn.hidden = !shouldShow;
      this.els.editBtn.classList.toggle('is-faded', hasCharms && isEdit);

      if (shouldShow && !isEdit && wasHidden) {
        this.animateEditButtonIn();
      }
    }
    if (this.els.addFirstCharm) {
      this.els.addFirstCharm.hidden = hasCharms || isEdit || isReview;
    }

    this.updateCharmCounter();
    this.updateRunningTotal();
    this.updateComplementaryNote();
    this.updateBespokeCharmsNote();
  };

  ProductBuilder.prototype.updateComplementaryNote = function () {
    if (!this.els.complementaryNote) return;

    var count = this.getComplementaryCharmCount();
    if (count <= 0) {
      this.els.complementaryNote.hidden = true;
      this.els.complementaryNote.textContent = '';
      return;
    }

    var message = count === 1
      ? 'Your first charm is complimentary.'
      : 'Your first ' + count + ' charms are complimentary.';

    this.els.complementaryNote.textContent = message;
    this.els.complementaryNote.hidden = this.step === 'review';
  };

  ProductBuilder.prototype.updateRunningTotal = function () {
    if (!this.els.runningTotalValue) return;
    this.els.runningTotalValue.textContent = formatMoney(
      this.getTotalPrice(),
      this.data.money_format
    );
  };

  // Slot positions tuned per count — calibrate 1-by-1 against live preview.
  ProductBuilder.SLOT_PRESETS = {
    1: [{ x: 49, y: 73.2, rotation: 0 }],
    2: [
      { x: 40, y: 70.4, rotation: 11 },
      { x: 60.5, y: 71, rotation: -15 }
    ],
    3: [
      { x: 28, y: 51.1, rotation: 60 },
      { x: 49, y: 73.2, rotation: 0 },
      { x: 72.4, y: 50, rotation: 300 }
    ],
    4: [
      { x: 32.5, y: 37.8, rotation: 116 },
      { x: 33, y: 65, rotation: 38 },
      { x: 67.3, y: 66, rotation: -47 },
      { x: 69, y: 38.4, rotation: -116 }
    ],
    5: [
      { x: 34.3, y: 35, rotation: 136 },
      { x: 29.6, y: 60, rotation: 48 },
      { x: 49, y: 73.2, rotation: 0 },
      { x: 71.6, y: 55.7, rotation: 299 },
      { x: 67.8, y: 36.4, rotation: 230 }
    ]
  };

  ProductBuilder.prototype.getPlacementMode = function () {
    var mode = this.placement.mode || 'slots';
    if (mode === 'along_chain' || mode === 'along_circle') {
      mode = 'slots';
    }
    return mode;
  };

  ProductBuilder.prototype.getSlotGroups = function () {
    var groups = this.placement.slot_groups;
    return groups && groups.length ? groups : [];
  };

  ProductBuilder.prototype.hasSlotGroups = function () {
    return this.getSlotGroups().length > 0;
  };

  ProductBuilder.prototype.getSlotGroupById = function (groupId) {
    var groups = this.getSlotGroups();
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].id === groupId) {
        return groups[i];
      }
    }
    return null;
  };

  ProductBuilder.prototype.getSelectedCharmCount = function () {
    if (!this.hasSlotGroups()) {
      return this.selectedCharms.length;
    }

    var count = 0;
    for (var i = 0; i < this.selectedCharms.length; i++) {
      if (this.selectedCharms[i]) count++;
    }
    return count;
  };

  ProductBuilder.prototype.getSelectedCharmsList = function () {
    if (!this.hasSlotGroups()) {
      return this.selectedCharms.slice();
    }

    var list = [];
    var indices = this.getGlobalAddOrder();

    for (var i = 0; i < indices.length; i++) {
      var charm = this.getCharmAtSlot(indices[i]);
      if (charm) list.push(charm);
    }

    return list;
  };

  ProductBuilder.prototype.getCharmAtSlot = function (slotIndex) {
    return this.selectedCharms[slotIndex] || null;
  };

  ProductBuilder.prototype.createEmptySlotStorage = function () {
    var size = this.getPoolMax();
    var arr = new Array(size);

    for (var i = 0; i < size; i++) {
      arr[i] = null;
    }

    return arr;
  };

  ProductBuilder.prototype.ensureSlotStorage = function () {
    if (!this.hasSlotGroups()) return;

    var size = this.getPoolMax();

    if (!Array.isArray(this.selectedCharms)) {
      this.selectedCharms = this.createEmptySlotStorage();
      return;
    }

    while (this.selectedCharms.length < size) {
      this.selectedCharms.push(null);
    }
  };

  ProductBuilder.prototype.getAllSlotIndices = function () {
    var indices = [];
    var groups = this.getSlotGroups();

    groups.forEach(function (group) {
      (group.slots || []).forEach(function (slotIndex) {
        if (indices.indexOf(slotIndex) === -1) {
          indices.push(slotIndex);
        }
      });
    });

    indices.sort(function (a, b) {
      return a - b;
    });

    return indices;
  };

  ProductBuilder.prototype.getAllSlotPositions = function () {
    return this.getCharmSlots(this.getPoolMax());
  };

  ProductBuilder.prototype.getOccupiedSlotsInGroup = function (group) {
    return this.getSlotFillOrder(group).filter(function (slotIndex) {
      return this.getCharmAtSlot(slotIndex);
    }, this);
  };

  ProductBuilder.prototype.getGlobalAddOrder = function () {
    var placement = this.placement || {};

    if (placement.add_order && placement.add_order.length) {
      return placement.add_order.map(function (slotIndex) {
        return Number(slotIndex);
      });
    }

    var groups = this.getSlotGroups();
    if (!groups.length) return [];

    var startIndex = 0;
    var startId = placement.alternate_from || placement.first_hoop;

    if (startId) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].id === startId) {
          startIndex = i;
          break;
        }
      }
    } else if (groups.length === 2) {
      startIndex = 1;
    }

    var groupOrders = groups.map(function (group) {
      return this.getSlotFillOrder(group);
    }, this);

    var maxRounds = 0;
    groupOrders.forEach(function (order) {
      if (order.length > maxRounds) maxRounds = order.length;
    });

    var sequence = [];
    for (var round = 0; round < maxRounds; round++) {
      for (var g = 0; g < groups.length; g++) {
        var order = groupOrders[(startIndex + g) % groups.length];
        if (round < order.length) {
          sequence.push(order[round]);
        }
      }
    }

    return sequence;
  };

  ProductBuilder.prototype.parseSlotSets = function (slotSets) {
    if (!slotSets) return null;

    if (typeof slotSets === 'string') {
      try {
        slotSets = JSON.parse(slotSets);
      } catch (e) {
        return null;
      }
    }

    return slotSets && typeof slotSets === 'object' ? slotSets : null;
  };

  ProductBuilder.prototype.getSlotSetEntry = function (slotSets, count) {
    var sets = this.parseSlotSets(slotSets);
    if (!sets) return null;

    var key = String(count);
    if (sets[key]) return sets[key];
    if (sets[count]) return sets[count];
    return null;
  };

  ProductBuilder.prototype.normalizePlacementConfig = function () {
    var placement = this.placement;
    if (!placement || !placement.slot_groups || !placement.slot_groups.length) return;

    var topSets = this.parseSlotSets(placement.slot_sets);
    if (topSets) {
      placement.slot_sets = topSets;
    }

    placement.slot_groups.forEach(function (group, groupIndex) {
      var groupSets = this.parseSlotSets(group.slot_sets);
      if (groupSets) {
        group.slot_sets = groupSets;
        return;
      }

      if (!topSets) return;

      if (groupIndex === 0) {
        group.slot_sets = {
          1: this.getSlotSetEntry(topSets, 1),
          2: this.getSlotSetEntry(topSets, 2)
        };
        return;
      }

      if (groupIndex === 1) {
        var three = this.getSlotSetEntry(topSets, 3) || [];
        var four = this.getSlotSetEntry(topSets, 4) || [];
        group.slot_sets = {
          1: three.length ? [three[three.length - 1]] : null,
          2: four.length >= 2 ? four.slice(-2) : null
        };
      }
    }, this);
  };

  ProductBuilder.prototype.getLegacyGroupSlotPositions = function (groupIndex, count) {
    var topSets = this.parseSlotSets(this.placement.slot_sets);
    if (!topSets) return null;

    if (groupIndex === 0) {
      return this.getSlotSetEntry(topSets, count);
    }

    if (groupIndex === 1) {
      if (count === 1) {
        var three = this.getSlotSetEntry(topSets, 3) || [];
        return three.length ? [three[three.length - 1]] : null;
      }

      if (count === 2) {
        var four = this.getSlotSetEntry(topSets, 4) || [];
        return four.length >= 2 ? four.slice(-2) : null;
      }
    }

    return null;
  };

  ProductBuilder.prototype.getGroupSlotPositions = function (group, count) {
    var self = this;
    var normalize = function (slot) {
      return self.normalizeSlot(slot, self.placement);
    };
    var groupSet = this.getSlotSetEntry(group.slot_sets, count);

    if (groupSet && groupSet.length) {
      return groupSet.map(normalize);
    }

    var groups = this.getSlotGroups();
    var groupIndex = groups.indexOf(group);
    var legacySet = this.getLegacyGroupSlotPositions(groupIndex, count);

    if (legacySet && legacySet.length) {
      return legacySet.map(normalize);
    }

    console.warn(
      '[ProductBuilder] Missing slot_sets for group',
      group.id,
      'with',
      count,
      'charm(s). Check custom.builder_config placement.slot_groups[].slot_sets.'
    );

    return [];
  };

  ProductBuilder.prototype.getPreviewSlotForIndex = function (slotIndex) {
    if (!this.hasSlotGroups()) {
      return null;
    }

    var group = this.getSlotGroupForIndex(slotIndex);
    if (!group || !this.getCharmAtSlot(slotIndex)) {
      return null;
    }

    var groupCount = this.countCharmsInGroup(group);
    var occupiedSlots = this.getOccupiedSlotsInGroup(group);
    var positionInGroup = occupiedSlots.indexOf(slotIndex);

    if (positionInGroup === -1) {
      return null;
    }

    var positions = this.getGroupSlotPositions(group, groupCount);
    return positions[positionInGroup] || null;
  };

  ProductBuilder.prototype.forEachSelectedCharm = function (callback, thisArg) {
    var context = thisArg || this;

    if (!this.hasSlotGroups()) {
      this.selectedCharms.forEach(function (charm, index) {
        if (!charm) return;
        callback.call(context, charm, index, index);
      });
      return;
    }

    var sequence = 0;
    var indices = this.getGlobalAddOrder();

    for (var i = 0; i < indices.length; i++) {
      var slotIndex = indices[i];
      var charm = this.getCharmAtSlot(slotIndex);
      if (!charm) continue;
      callback.call(context, charm, slotIndex, sequence);
      sequence++;
    }
  };

  ProductBuilder.prototype.getSlotGroupForIndex = function (index) {
    var groups = this.getSlotGroups();
    for (var i = 0; i < groups.length; i++) {
      var slots = groups[i].slots || [];
      if (slots.indexOf(index) !== -1) {
        return groups[i];
      }
    }
    return null;
  };

  ProductBuilder.prototype.countCharmsInGroup = function (group) {
    if (!group) return 0;
    var slots = group.slots || [];
    var count = 0;

    for (var i = 0; i < slots.length; i++) {
      if (this.getCharmAtSlot(slots[i])) {
        count++;
      }
    }

    return count;
  };

  ProductBuilder.prototype.getPreferredAddGroupIndex = function () {
    var placement = this.placement || {};
    var groups = this.getSlotGroups();
    var startId = placement.alternate_from || placement.first_hoop;
    var startIndex = 1;

    if (startId) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].id === startId) {
          startIndex = i;
          break;
        }
      }
    } else if (groups.length === 2) {
      startIndex = 1;
    } else {
      startIndex = 0;
    }

    return this.getSelectedCharmCount() % 2 === 0 ? startIndex : (startIndex === 0 ? 1 : 0);
  };

  ProductBuilder.prototype.getSlotFillOrder = function (group) {
    if (group.add_order && group.add_order.length) {
      return group.add_order.slice();
    }

    var slots = (group.slots || []).slice().sort(function (a, b) {
      return a - b;
    });
    var groups = this.getSlotGroups();
    var groupIndex = groups.indexOf(group);

    if (groups.length === 2 && slots.length === 2 && groupIndex === 0) {
      return [slots[1], slots[0]];
    }

    return slots;
  };

  ProductBuilder.prototype.getFirstEmptySlotInGroup = function (group) {
    var slots = this.getSlotFillOrder(group);

    for (var i = 0; i < slots.length; i++) {
      if (!this.getCharmAtSlot(slots[i])) {
        return slots[i];
      }
    }

    return -1;
  };

  ProductBuilder.prototype.getGroupMax = function (group) {
    if (!group) return 0;
    if (group.max != null) return group.max;
    return (group.slots || []).length;
  };

  ProductBuilder.prototype.getNextAddIndex = function () {
    if (!this.hasSlotGroups()) {
      return this.getSelectedCharmCount() >= this.getPoolMax()
        ? -1
        : this.selectedCharms.length;
    }

    if (this.getSelectedCharmCount() >= this.getPoolMax()) return -1;

    this.ensureSlotStorage();

    var order = this.getGlobalAddOrder();
    for (var i = 0; i < order.length; i++) {
      if (!this.getCharmAtSlot(order[i])) {
        return order[i];
      }
    }

    return -1;
  };

  ProductBuilder.prototype.getGroupLimitMessage = function () {
    if (!this.hasSlotGroups()) return '';

    if (this.getNextAddIndex() !== -1 || this.getSelectedCharmCount() >= this.getPoolMax()) {
      return '';
    }

    return 'All charm slots are full. Remove a charm to continue.';
  };

  ProductBuilder.prototype.resolveSlotDropTarget = function (fromSlot, toSlot) {
    if (fromSlot == null || toSlot == null) return toSlot;
    if (fromSlot === toSlot) return toSlot;

    this.ensureSlotStorage();

    if (!this.getCharmAtSlot(toSlot)) {
      return toSlot;
    }

    var fromGroup = this.getSlotGroupForIndex(fromSlot);
    var toGroup = this.getSlotGroupForIndex(toSlot);

    if (!fromGroup || !toGroup || fromGroup.id === toGroup.id) {
      return toSlot;
    }

    var emptySlot = this.getFirstEmptySlotInGroup(toGroup);
    if (emptySlot !== -1) {
      return emptySlot;
    }

    return toSlot;
  };

  ProductBuilder.prototype.moveCharmToSlot = function (fromSlot, toSlot) {
    if (fromSlot == null || toSlot == null || fromSlot === toSlot) return false;

    this.ensureSlotStorage();

    toSlot = this.resolveSlotDropTarget(fromSlot, toSlot);
    if (fromSlot === toSlot) return false;

    var charm = this.getCharmAtSlot(fromSlot);
    if (!charm) return false;

    var targetCharm = this.getCharmAtSlot(toSlot);
    this.selectedCharms[fromSlot] = targetCharm || null;
    this.selectedCharms[toSlot] = charm;
    return true;
  };

  ProductBuilder.prototype.wouldReorderViolateGroups = function (fromIndex, toIndex) {
    if (!this.hasSlotGroups()) return false;
    if (fromIndex == null || toIndex == null || fromIndex === toIndex) return false;

    toIndex = this.resolveSlotDropTarget(fromIndex, toIndex);
    if (fromIndex === toIndex) return false;

    var copy = this.selectedCharms.slice();
    var moved = copy[fromIndex];
    if (!moved) return false;

    copy[fromIndex] = copy[toIndex] || null;
    copy[toIndex] = moved;

    var groups = this.getSlotGroups();
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var slots = group.slots || [];
      var max = this.getGroupMax(group);
      var count = 0;

      for (var s = 0; s < slots.length; s++) {
        if (copy[slots[s]]) {
          count++;
        }
      }

      if (count > max) {
        return true;
      }
    }

    return false;
  };

  ProductBuilder.prototype.updateEditHint = function () {
    if (!this.els.editHint) return;

    if (this.hasSlotGroups()) {
      this.els.editHint.textContent = 'Drag charms between hoops to reorder them';
      return;
    }

    this.els.editHint.textContent = 'Drag charms to reorder them';
  };

  ProductBuilder.prototype.getDefaultCharmSizePercent = function () {
    var placement = this.placement || {};
    return placement.charm_size_percent != null ? placement.charm_size_percent : 8;
  };

  ProductBuilder.prototype.getConfigCharmSizePercent = function (productHandle, groupId) {
    if (!productHandle) return null;

    var placement = this.placement || {};
    if (placement.charm_sizes && placement.charm_sizes[productHandle] != null) {
      return placement.charm_sizes[productHandle];
    }

    var groups = this.config.charms || this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (groupId && group.id && group.id !== groupId) continue;

      if (group.product_handle === productHandle && group.size_percent != null) {
        return group.size_percent;
      }

      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        var handle = typeof entry === 'string' ? entry : entry.product_handle;
        if (handle !== productHandle) continue;
        if (typeof entry !== 'string' && entry.size_percent != null) {
          return entry.size_percent;
        }
        break;
      }
    }

    return null;
  };

  ProductBuilder.prototype.resolveCharmSizePercent = function (options) {
    options = options || {};
    var defaultSize = this.getDefaultCharmSizePercent();

    if (options.slot) {
      var slotSize = options.slot.size_percent != null
        ? options.slot.size_percent
        : options.slot.charm_size_percent;
      if (slotSize != null) return Number(slotSize);
    }

    if (options.size_percent != null) return Number(options.size_percent);

    if (options.charm && options.charm.size_percent != null) {
      return Number(options.charm.size_percent);
    }

    var handle = options.product_handle || (options.charm && options.charm.product_handle);
    var groupId = options.groupId || (options.charm && options.charm.groupId);
    var mapped = this.getConfigCharmSizePercent(handle, groupId);
    if (mapped != null) return Number(mapped);

    return defaultSize;
  };

  ProductBuilder.prototype.normalizeSlot = function (slot, placement) {
    var x = slot.x_percent != null ? slot.x_percent : slot.x;
    var y = slot.y_percent != null ? slot.y_percent : slot.y;
    var rotation = slot.rotation;

    if (rotation == null) {
      rotation = 0;
    }

    var sizePercent = slot.size_percent != null ? slot.size_percent : slot.charm_size_percent;

    return {
      x: x,
      y: y,
      rotation: rotation,
      size_percent: sizePercent != null ? Number(sizePercent) : null
    };
  };

  ProductBuilder.prototype.getCharmSlots = function (count) {
    var placement = this.placement;
    var self = this;
    var normalize = function (slot) {
      return self.normalizeSlot(slot, placement);
    };

    // Custom slots only when explicitly opted in — avoids stale metafield overrides.
    if (placement.custom_slots) {
      var customSet = this.getSlotSetEntry(placement.slot_sets, count);
      if (customSet && customSet.length) {
        return customSet.map(normalize);
      }
      if (placement.slots && placement.slots[count]) {
        return placement.slots[count].map(normalize);
      }
      if (this.hasSlotGroups()) {
        return [];
      }
    }

    if (ProductBuilder.SLOT_PRESETS[count]) {
      return ProductBuilder.SLOT_PRESETS[count].map(normalize);
    }

    if (ProductBuilder.SLOT_PRESETS[5]) {
      return ProductBuilder.SLOT_PRESETS[5].slice(0, count).map(normalize);
    }

    return [];
  };

  ProductBuilder.prototype.usesHangCharmAnimation = function () {
    var placement = this.placement || {};

    if (placement.hang_animation === false) return false;
    if (placement.hang_animation === true || placement.charm_animation === 'hang') return true;

    // Backward compatible: grouped layouts keep hang animation unless disabled.
    return this.hasSlotGroups();
  };

  ProductBuilder.prototype.getPreviewCharmAnimation = function (charm, slotIndex, slot) {
    if (!charm || !charm.instanceId) return 'none';

    var prev = this.previewCharmStates[charm.instanceId];
    if (!prev) return 'enter';
    if (prev.slotIndex !== slotIndex) return 'enter';

    if (slot && (
      prev.x !== slot.x ||
      prev.y !== slot.y ||
      prev.rotation !== slot.rotation
    )) {
      return 'settle';
    }

    return 'none';
  };

  ProductBuilder.prototype.syncPreviewCharmState = function (charm, slotIndex, slot) {
    if (!charm || !charm.instanceId) return;

    this.previewCharmStates[charm.instanceId] = {
      slotIndex: slotIndex,
      x: slot ? slot.x : null,
      y: slot ? slot.y : null,
      rotation: slot ? slot.rotation : null
    };
  };

  ProductBuilder.prototype.prunePreviewCharmStates = function () {
    var active = {};

    this.forEachSelectedCharm(function (charm, slotIndex) {
      if (charm.instanceId) {
        active[charm.instanceId] = true;
      }
    });

    for (var id in this.previewCharmStates) {
      if (!active[id]) {
        delete this.previewCharmStates[id];
      }
    }
  };

  ProductBuilder.prototype.appendGroupedPreviewCharm = function (layer, charm, slot, slotIndex, sequence) {
    var charmSizePercent = this.resolveCharmSizePercent({
      charm: charm,
      slot: slot
    });
    var animation = this.getPreviewCharmAnimation(charm, slotIndex, slot);

    var img = configureBuilderImage(document.createElement('img'));
    img.src = this.resolveCharmPreviewImageUrl(charm.preview_image);
    img.alt = charm.letter;
    img.className = 'product-builder__charm-on-canvas product-builder__charm-on-canvas--hang';
    img.style.left = slot.x + '%';
    img.style.top = slot.y + '%';
    img.style.width = charmSizePercent + '%';
    img.style.setProperty('--charm-rotate', slot.rotation + 'deg');

    if (animation === 'enter') {
      img.classList.add('is-entering');
    } else if (animation === 'settle') {
      img.classList.add('is-settling');
    }

    layer.appendChild(img);
    this.syncPreviewCharmState(charm, slotIndex, slot);
  };

  ProductBuilder.prototype.renderPreviewSlots = function (layer, placement) {
    var self = this;

    if (this.hasSlotGroups()) {
      var slotIndices = this.getGlobalAddOrder();
      var sequence = 0;

      slotIndices.forEach(function (slotIndex) {
        var charm = self.getCharmAtSlot(slotIndex);
        if (!charm) return;

        var slot = self.getPreviewSlotForIndex(slotIndex);
        if (!slot) return;

        self.appendGroupedPreviewCharm(layer, charm, slot, slotIndex, sequence);
        sequence++;
      });

      this.prunePreviewCharmStates();
      return;
    }

    var slots = this.getCharmSlots(this.selectedCharms.length);
    var useHangAnimation = this.usesHangCharmAnimation();

    this.selectedCharms.forEach(function (charm, index) {
      var slot = slots[index];
      if (!slot) return;

      if (useHangAnimation) {
        self.appendGroupedPreviewCharm(layer, charm, slot, index, index);
        return;
      }

      var charmSizePercent = self.resolveCharmSizePercent({
        charm: charm,
        slot: slot
      });

      var img = configureBuilderImage(document.createElement('img'));
      img.src = self.resolveCharmPreviewImageUrl(charm.preview_image);
      img.alt = charm.letter;
      img.className = 'product-builder__charm-on-canvas';
      img.style.left = slot.x + '%';
      img.style.top = slot.y + '%';
      img.style.width = charmSizePercent + '%';
      img.style.transform = 'translate(-50%, 0) rotate(' + slot.rotation + 'deg)';
      layer.appendChild(img);
    });

    if (useHangAnimation) {
      this.prunePreviewCharmStates();
    }
  };

  ProductBuilder.prototype.renderPreviewLine = function (layer, placement) {
    var self = this;
    var charms = this.getSelectedCharmsList();
    var count = charms.length;
    var spacingPercent = placement.spacing_percent || 4.5;
    var offsetX = placement.offset_x_percent || 50;
    var offsetY = placement.offset_y_percent || 78;
    var sizes = charms.map(function (charm) {
      return self.resolveCharmSizePercent({ charm: charm });
    });
    var totalWidth = 0;

    for (var i = 0; i < count; i++) {
      totalWidth += sizes[i];
      if (i < count - 1) totalWidth += spacingPercent;
    }

    var cursorX = offsetX - totalWidth / 2;

    charms.forEach(function (charm, index) {
      var charmSizePercent = sizes[index];
      var img = configureBuilderImage(document.createElement('img'));
      img.src = self.resolveCharmPreviewImageUrl(charm.preview_image);
      img.alt = charm.letter;
      img.className = 'product-builder__charm-on-canvas';
      img.style.left = cursorX + charmSizePercent / 2 + '%';
      img.style.top = offsetY + '%';
      img.style.width = charmSizePercent + '%';
      img.style.transform = 'translate(-50%, -50%)';
      layer.appendChild(img);
      cursorX += charmSizePercent + spacingPercent;
    });
  };

  ProductBuilder.prototype.renderPreview = function () {
    var layer = this.els.charmsLayer;
    if (!layer) return;

    this.applyPreviewAppearance();
    layer.classList.toggle('product-builder__charms-layer--hang', this.usesHangCharmAnimation());
    layer.innerHTML = '';
    if (!this.getSelectedCharmCount()) return;

    var canvas = this.root.querySelector('[data-builder-canvas]');
    if (!canvas) return;

    var placement = this.placement;
    var mode = this.getPlacementMode();
    if (mode === 'slots') {
      this.renderPreviewSlots(layer, placement);
    } else if (mode === 'along_line') {
      this.renderPreviewLine(layer, placement);
    } else {
      this.renderPreviewSlots(layer, placement);
    }
  };

  ProductBuilder.prototype.ensureDropPlaceholder = function () {
    if (!this.dropPlaceholder) {
      this.dropPlaceholder = document.createElement('div');
      this.dropPlaceholder.className = 'product-builder__drop-placeholder';
      this.dropPlaceholder.setAttribute('aria-hidden', 'true');
    }
    return this.dropPlaceholder;
  };

  ProductBuilder.prototype.getDragDropContainer = function () {
    return this.els.selectedCharms || null;
  };

  ProductBuilder.prototype.getDraggableCharmItems = function (container, draggingEl) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll('.product-builder__selected-charm:not(.is-empty-slot)')
    ).filter(function (el) {
      return el !== draggingEl;
    });
  };

  ProductBuilder.prototype.getSlotElementsForHitTest = function (container) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll('.product-builder__slot-group-charms [data-index]')
    );
  };

  ProductBuilder.prototype.getCharmDropSlotIndex = function (clientX, clientY, draggingEl) {
    var fromSlot = Number(draggingEl.dataset.index);
    var container = this.getDragDropContainer();
    if (!container) return fromSlot;

    var slots = this.getSlotElementsForHitTest(container);
    var hitSlot = null;

    for (var i = 0; i < slots.length; i++) {
      var rect = slots[i].getBoundingClientRect();
      if (
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom
      ) {
        hitSlot = Number(slots[i].dataset.index);
        break;
      }
    }

    if (hitSlot == null) {
      var closestDist = Infinity;

      for (var j = 0; j < slots.length; j++) {
        var slotRect = slots[j].getBoundingClientRect();
        var centerX = slotRect.left + slotRect.width / 2;
        var centerY = slotRect.top + slotRect.height / 2;
        var dist = Math.pow(clientX - centerX, 2) + Math.pow(clientY - centerY, 2);

        if (dist < closestDist) {
          closestDist = dist;
          hitSlot = Number(slots[j].dataset.index);
        }
      }
    }

    if (hitSlot == null) return fromSlot;

    return this.resolveSlotDropTarget(fromSlot, hitSlot);
  };

  ProductBuilder.prototype.getCharmDropIndex = function (clientX, clientY, draggingEl) {
    var container = this.getDragDropContainer();
    if (!container) return 0;

    if (this.hasSlotGroups() && draggingEl) {
      return this.getCharmDropSlotIndex(clientX, clientY, draggingEl);
    }

    var items = this.getDraggableCharmItems(container, draggingEl);

    for (var i = 0; i < items.length; i++) {
      var rect = items[i].getBoundingClientRect();
      if (clientX < rect.left + rect.width / 2) {
        return Number(items[i].dataset.index);
      }
    }

    if (!items.length) return 0;

    var lastIndex = Number(items[items.length - 1].dataset.index);
    return lastIndex + 1;
  };

  ProductBuilder.prototype.updateSlotGroupDropTarget = function (targetSlotIndex) {
    var container = this.els.selectedCharms;
    if (!container) return;

    if (this.dragInsertIndex === targetSlotIndex) {
      return;
    }

    container.querySelectorAll('.is-drop-target').forEach(function (el) {
      el.classList.remove('is-drop-target');
    });

    this.dragInsertIndex = targetSlotIndex;

    var targetEl = container.querySelector('[data-index="' + targetSlotIndex + '"]');
    if (targetEl) {
      targetEl.classList.add('is-drop-target');
    }
  };

  ProductBuilder.prototype.updateDropPlaceholder = function (targetSlotIndex) {
    if (this.draggingEl == null) return;

    if (this.hasSlotGroups()) {
      this.updateSlotGroupDropTarget(targetSlotIndex);
      return;
    }

    var container = this.getDragDropContainer();
    if (!container) return;

    var flatItems = this.getDraggableCharmItems(container, this.draggingEl);
    var placeholderBefore = null;

    for (var i = 0; i < flatItems.length; i++) {
      if (Number(flatItems[i].dataset.index) === targetSlotIndex) {
        placeholderBefore = flatItems[i];
        break;
      }
    }

    if (
      this.dragInsertIndex === targetSlotIndex &&
      this.dropPlaceholder &&
      this.dropPlaceholder.parentNode === container
    ) {
      return;
    }

    var placeholder = this.ensureDropPlaceholder();
    this.dragInsertIndex = targetSlotIndex;
    placeholder.classList.add('is-visible');

    if (placeholderBefore) {
      container.insertBefore(placeholder, placeholderBefore);
      return;
    }

    container.appendChild(placeholder);
  };

  ProductBuilder.prototype.clearCharmDragState = function () {
    var container = this.els.selectedCharms;
    if (container) {
      container.classList.remove('is-drag-active');
      container.querySelectorAll('.product-builder__selected-charm.is-dragging').forEach(function (el) {
        el.classList.remove('is-dragging', 'is-dragging-collapsed');
      });
      container.querySelectorAll('.product-builder__slot-group-charms.is-drag-active').forEach(function (el) {
        el.classList.remove('is-drag-active');
      });
      container.querySelectorAll('.is-drop-target').forEach(function (el) {
        el.classList.remove('is-drop-target');
      });
    }

    if (this.dropPlaceholder) {
      this.dropPlaceholder.classList.remove('is-visible');
      if (this.dropPlaceholder.parentNode) {
        this.dropPlaceholder.parentNode.removeChild(this.dropPlaceholder);
      }
    }

    if (this.dragCloneEl && this.dragCloneEl.parentNode) {
      this.dragCloneEl.parentNode.removeChild(this.dragCloneEl);
    }

    document.body.classList.remove('product-builder-dragging');

    this.dragFromIndex = null;
    this.dragInsertIndex = null;
    this.draggingEl = null;
    this.dragCloneEl = null;
    this.dragPointerId = null;
    this.dragActive = false;
  };

  ProductBuilder.prototype.reorderSelectedCharm = function (fromIndex, toIndex) {
    if (fromIndex == null || toIndex == null) return false;

    if (this.hasSlotGroups()) {
      toIndex = this.resolveSlotDropTarget(fromIndex, toIndex);
      if (fromIndex === toIndex) return false;
      if (this.wouldReorderViolateGroups(fromIndex, toIndex)) {
        return false;
      }
      return this.moveCharmToSlot(fromIndex, toIndex);
    }

    if (fromIndex === toIndex) return false;

    var targetIndex = toIndex;
    if (targetIndex > fromIndex) {
      targetIndex--;
    }
    if (targetIndex === fromIndex) return false;

    var moved = this.selectedCharms.splice(fromIndex, 1)[0];
    this.selectedCharms.splice(targetIndex, 0, moved);
    return true;
  };

  ProductBuilder.CHARM_DRAG_THRESHOLD = 8;

  ProductBuilder.prototype.createDragClone = function (item) {
    var sourceImg = item.querySelector('img');
    var clone = document.createElement('div');
    clone.className = 'product-builder__drag-clone';

    if (sourceImg) {
      var cloneImg = configureBuilderImage(document.createElement('img'));
      cloneImg.src = sourceImg.src;
      cloneImg.alt = sourceImg.alt;
      clone.appendChild(cloneImg);
    }

    document.body.appendChild(clone);
    this.dragCloneEl = clone;
    return clone;
  };

  ProductBuilder.prototype.moveDragClone = function (clientX, clientY, offsetX, offsetY) {
    if (!this.dragCloneEl) return;
    this.dragCloneEl.style.left = (clientX - offsetX) + 'px';
    this.dragCloneEl.style.top = (clientY - offsetY) + 'px';
  };

  ProductBuilder.prototype.startCharmPointerReorder = function (item, event) {
    var self = this;
    var container = this.els.selectedCharms;
    if (!container || this.draggingEl) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    var startX = event.clientX;
    var startY = event.clientY;
    var rect = item.getBoundingClientRect();
    var offsetX = event.clientX - rect.left;
    var offsetY = event.clientY - rect.top;

    this.dragFromIndex = Number(item.dataset.index);
    this.dragPointerId = event.pointerId;
    this.dragActive = false;

    var onMove = function (e) {
      if (e.pointerId !== self.dragPointerId) return;

      if (!self.dragActive) {
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.sqrt(dx * dx + dy * dy) < ProductBuilder.CHARM_DRAG_THRESHOLD) return;

        self.dragActive = true;
        self.draggingEl = item;
        container.classList.add('is-drag-active');
        item.classList.add('is-dragging', 'is-dragging-collapsed');
        document.body.classList.add('product-builder-dragging');
        self.createDragClone(item);
        self.moveDragClone(e.clientX, e.clientY, offsetX, offsetY);
        self.updateDropPlaceholder(self.getCharmDropIndex(e.clientX, e.clientY, item));

        try {
          item.setPointerCapture(e.pointerId);
        } catch (err) {
          // Pointer capture may be unsupported in older browsers.
        }
      }

      if (e.cancelable) e.preventDefault();
      self.moveDragClone(e.clientX, e.clientY, offsetX, offsetY);
      self.updateDropPlaceholder(self.getCharmDropIndex(e.clientX, e.clientY, self.draggingEl));
    };

    var onEnd = function (e) {
      if (e.pointerId !== self.dragPointerId) return;

      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onEnd);
      document.removeEventListener('pointercancel', onEnd);

      try {
        item.releasePointerCapture(e.pointerId);
      } catch (err) {
        // Ignore release failures after drag end.
      }

      var shouldReorder = self.dragActive;
      var fromIndex = self.dragFromIndex;
      var toIndex = self.dragInsertIndex;
      self.clearCharmDragState();

      if (shouldReorder && self.reorderSelectedCharm(fromIndex, toIndex)) {
        self.renderSelectedCharmsTray();
        self.renderPreview();
      }
    };

    document.addEventListener('pointermove', onMove, { passive: false });
    document.addEventListener('pointerup', onEnd);
    document.addEventListener('pointercancel', onEnd);
  };

  ProductBuilder.prototype.createSelectedCharmItem = function (charm, index) {
    var self = this;
    var item = document.createElement('div');
    item.className = 'product-builder__selected-charm';
    item.dataset.index = String(index);

    var img = configureBuilderImage(document.createElement('img'));
    img.src = this.resolveCharmPreviewImageUrl(charm.preview_image);
    img.alt = charm.letter;
    item.appendChild(img);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'product-builder__selected-charm-remove';
    removeBtn.setAttribute('aria-label', 'Remove ' + charm.letter);
    removeBtn.textContent = '×';
    removeBtn.addEventListener('pointerdown', function (e) {
      e.stopPropagation();
    });
    removeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (self.hasSlotGroups()) {
        self.selectedCharms[index] = null;
      } else {
        self.selectedCharms.splice(index, 1);
      }
      self.renderSelectedCharmsTray();
      self.renderCharmGrid();
      self.renderPreview();
      if (self.getSelectedCharmCount() === 0 && self.step === 'edit') {
        self.setStep('choose');
      } else {
        self.updateEditButtonVisibility();
      }
    });
    item.appendChild(removeBtn);

    item.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.product-builder__selected-charm-remove')) return;
      self.startCharmPointerReorder(item, e);
    });

    return item;
  };

  ProductBuilder.prototype.createEmptySlotPlaceholder = function (slotIndex) {
    var placeholder = document.createElement('div');
    placeholder.className = 'product-builder__selected-charm is-empty-slot';
    placeholder.dataset.index = String(slotIndex);
    placeholder.setAttribute('aria-hidden', 'true');
    return placeholder;
  };

  ProductBuilder.prototype.renderSelectedCharmsTray = function () {
    var container = this.els.selectedCharms;
    if (!container) return;

    this.clearCharmDragState();
    this.updateEditHint();

    var self = this;
    container.innerHTML = '';
    container.classList.toggle('has-slot-groups', this.hasSlotGroups());

    if (!this.hasSlotGroups()) {
      this.selectedCharms.forEach(function (charm, index) {
        container.appendChild(self.createSelectedCharmItem(charm, index));
      });
      return;
    }

    this.getSlotGroups().forEach(function (group) {
      var groupWrap = document.createElement('div');
      groupWrap.className = 'product-builder__slot-group';
      groupWrap.dataset.slotGroup = group.id;

      var heading = document.createElement('p');
      heading.className = 'product-builder__slot-group-label';
      heading.textContent = group.label || group.id;
      groupWrap.appendChild(heading);

      var row = document.createElement('div');
      row.className = 'product-builder__slot-group-charms';

      self.getSlotFillOrder(group).forEach(function (slotIndex) {
        var charm = self.getCharmAtSlot(slotIndex);
        if (charm) {
          row.appendChild(self.createSelectedCharmItem(charm, slotIndex));
        } else {
          row.appendChild(self.createEmptySlotPlaceholder(slotIndex));
        }
      });

      groupWrap.appendChild(row);
      container.appendChild(groupWrap);
    });
  };

  ProductBuilder.prototype.renderReview = function () {
    var list = this.els.reviewList;
    if (!list) return;

    list.innerHTML = '';
    var base = this.getBaseVariant();

    if (base) {
      list.appendChild(this.createReviewItem({
        image: this.data.base.preview_image,
        title: this.data.base.title,
        subtitle: this.getBaseReviewSubtitle(),
        price: base.price,
        isBase: true
      }));
    }

    this.forEachSelectedCharm(function (charm, slotIndex, sequence) {
      list.appendChild(this.createReviewItem({
        image: charm.preview_image,
        title: charm.product_title || (this.charmGroup && this.charmGroup.product_title) || 'Charm',
        subtitle: this.getCharmReviewSubtitle(charm),
        slotLabel: this.hasSlotGroups() ? this.getSlotPlacementLabel(slotIndex) : '',
        price: charm.price,
        isComplementary: this.isComplementaryCharmIndex(sequence)
      }));
    }, this);

    this.updateRunningTotal();
  };

  ProductBuilder.prototype.getBaseReviewSubtitle = function () {
    var base = this.getBaseVariant();
    if (!base) return '';

    var variants = (this.data.base && this.data.base.variants) || [];
    if (variants.length <= 1) return '';

    var title = (base.title || '').trim();
    if (!title || /^default\s+title$/i.test(title)) return '';

    return title;
  };

  ProductBuilder.prototype.createReviewItem = function (item) {
    var li = document.createElement('li');
    li.className = 'product-builder__review-item';
    if (item.isBase) {
      li.classList.add('is-base');
    }
    if (item.isComplementary) {
      li.classList.add('is-complementary');
    }

    var thumb = document.createElement('div');
    thumb.className = 'product-builder__review-item-thumb';

    var img = configureBuilderImage(document.createElement('img'));
    img.src = item.image || '';
    img.alt = item.title;
    thumb.appendChild(img);
    li.appendChild(thumb);

    var details = document.createElement('div');
    details.className = 'product-builder__review-item-details';

    var title = document.createElement('div');
    title.className = 'product-builder__review-item-title';
    title.textContent = item.title;

    details.appendChild(title);

    if (item.subtitle) {
      var subtitle = document.createElement('div');
      subtitle.className = 'product-builder__review-item-subtitle';
      subtitle.textContent = item.subtitle;
      details.appendChild(subtitle);
    }

    if (item.slotLabel) {
      var badge = document.createElement('div');
      badge.className = 'product-builder__review-item-badge';
      badge.textContent = item.slotLabel;
      details.appendChild(badge);
    }

    li.appendChild(details);

    var price = document.createElement('div');
    price.className = 'product-builder__review-item-price';

    if (item.isComplementary) {
      var original = document.createElement('s');
      original.className = 'product-builder__review-item-price-original';
      original.textContent = formatMoney(item.price, this.data.money_format);

      var free = document.createElement('span');
      free.className = 'product-builder__review-item-price-free';
      free.textContent = this.getComplementaryLabel();

      price.appendChild(original);
      price.appendChild(free);
    } else {
      price.textContent = formatMoney(item.price, this.data.money_format);
    }

    li.appendChild(price);

    return li;
  };

  ProductBuilder.prototype.getProductFormVariantSelect = function () {
    return document.querySelector('#productForm [data-product-select]');
  };

  ProductBuilder.prototype.syncProductPageVariant = function (variant) {
    if (!variant) return;

    var masterSelect = this.getProductFormVariantSelect();
    if (masterSelect) {
      masterSelect.value = String(variant.id);
    }

    var section = document.querySelector('[data-section-type="product"]');
    var optionSelectors = section
      ? section.querySelectorAll('[data-single-option-selector]')
      : [];

    if (!optionSelectors.length) {
      this.updateVariantUrl(variant.id);
      return;
    }

    optionSelectors.forEach(function (el) {
      var index = el.dataset.index;
      if (!index || index.indexOf('option') !== 0) return;

      var pos = index.replace('option', '');
      var value = variant['option' + pos];
      if (!value) return;

      if (el.type === 'radio' || el.type === 'checkbox') {
        el.checked = el.value === value;
      } else {
        el.value = value;
      }
    });

    var trigger = optionSelectors[0];
    if (typeof jQuery !== 'undefined') {
      jQuery(trigger).trigger('change');
    } else if (trigger) {
      trigger.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      this.updateVariantUrl(variant.id);
    }
  };

  ProductBuilder.prototype.updateVariantUrl = function (variantId) {
    if (!window.history.replaceState || !variantId) return;
    var newurl = window.location.protocol + '//' + window.location.host
      + window.location.pathname + '?variant=' + variantId;
    window.history.replaceState({ path: newurl }, '', newurl);
  };

  ProductBuilder.prototype.syncVariantFromProductForm = function () {
    var masterSelect = this.getProductFormVariantSelect();
    if (masterSelect && masterSelect.value) {
      this.baseVariantId = Number(masterSelect.value);
      this.updateBasePreview();
      this.updateRunningTotal();
      this.updateLaunchButton();
      return;
    }

    this.syncVariantFromOptionSelectors();
  };

  ProductBuilder.prototype.getLetterFromVariant = function (variant, options) {
    if (options && options.length) {
      for (var i = 0; i < options.length; i++) {
        if (/letter/i.test(options[i])) {
          return variant['option' + (i + 1)] || variant.title;
        }
      }
    }
    return variant.title;
  };

  ProductBuilder.prototype.getCharmProductHandles = function () {
    var handles = [];
    var seen = {};

    this.charmGroups.forEach(function (group) {
      var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

      if (groupType === 'products' && group.products) {
        group.products.forEach(function (product) {
          if (product.product_handle && !seen[product.product_handle]) {
            seen[product.product_handle] = true;
            handles.push(product.product_handle);
          }
        });
      } else if (group.product_handle && !seen[group.product_handle]) {
        seen[group.product_handle] = true;
        handles.push(group.product_handle);
      }
    });

    return handles;
  };

  ProductBuilder.prototype.applyLiveVariantStock = function (variant, live) {
    this.syncVariantInventory(variant, live, {});
  };

  ProductBuilder.prototype.validateSelectedCharmStock = function () {
    var counts = {};

    this.getSelectedCharmsList().forEach(function (charm) {
      var id = String(charm.id);
      counts[id] = (counts[id] || 0) + 1;
    });

    for (var variantId in counts) {
      var tile = this.getCharmVariant(variantId);
      if (!tile) continue;

      if (!this.isVariantPurchasable(tile)) {
        return '"' + (tile.label || tile.letter) + '" is no longer available.';
      }

      var cap = this.getVariantStockCap(tile);
      if (cap !== null && counts[variantId] > cap) {
        var label = tile.label || tile.letter;
        return cap === 1
          ? 'Only 1 "' + label + '" is available.'
          : 'Only ' + cap + ' "' + label + '" charms are available.';
      }
    }

    return '';
  };

  ProductBuilder.prototype.applyLiveProductToGroup = function (group, product) {
    var self = this;
    var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

    if (groupType === 'products' && group.products) {
      group.products.forEach(function (entry) {
        if (entry.product_handle !== product.handle) return;

        if (!entry.product_title) {
          entry.product_title = product.title;
        }

        var variantEntry = self.buildCharmProductVariantEntry(product, entry);
        if (!variantEntry) return;

        if (!entry.preview_image && variantEntry.preview_image) {
          entry.preview_image = variantEntry.preview_image;
        }

        if (!entry.preview_image_blank) {
          entry.preview_image_blank = self.resolveBlankPreviewImage(product, entry);
        }

        entry.gallery_images = self.getProductGalleryImages(product, entry);
        entry.variants = [variantEntry];
      });
      return;
    }

    if (group.product_handle !== product.handle) return;

    if (!group.product_title) {
      group.product_title = product.title;
    }

    if (!group.variants || !group.variants.length) {
      group.variants = (product.variants || []).map(function (v) {
        var letter = self.getLetterFromVariant(v, product.options);
        return {
          id: v.id,
          letter: letter,
          title: v.title,
          price: v.price,
          available: v.available,
          inventory_quantity: v.inventory_quantity,
          inventory_management: v.inventory_management || null,
          inventory_policy: v.inventory_policy || 'deny',
          preview_image: self.getVariantPreviewImage(v, product),
          sku: v.sku,
          design_token: letter
        };
      });
      return;
    }

    var variantMap = {};
    (product.variants || []).forEach(function (v) {
      variantMap[v.id] = v;
    });

    group.variants.forEach(function (variant) {
      var live = variantMap[variant.id];
      if (!live) return;
      self.applyLiveVariantStock(variant, live);
      if (!variant.preview_image) {
        variant.preview_image = self.getVariantPreviewImage(live, product);
      }
    });
  };

  ProductBuilder.prototype.refreshBaseVariantStock = function () {
    var self = this;
    var handle = this.data.base && this.data.base.handle;

    if (!handle) return Promise.resolve();

    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.json();
      })
      .then(function (product) {
        var live = (product.variants || []).find(function (variant) {
          return Number(variant.id) === Number(self.baseVariantId);
        });

        if (live) {
          self.applyBaseVariantFromLive(live);
        }
      })
      .catch(function (err) {
        console.warn('[ProductBuilder] Could not refresh base stock for ' + handle, err);
      });
  };

  ProductBuilder.prototype.enrichCharmStock = function () {
    var self = this;
    var handles = this.getCharmProductHandles();

    if (!handles.length) {
      this.syncCharmTiles();
      return Promise.resolve();
    }

    return Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found: ' + handle);
          return res.json();
        })
        .then(function (product) {
          self.charmGroups.forEach(function (group) {
            self.applyLiveProductToGroup(group, product);
          });
        })
        .catch(function (err) {
          console.warn('[ProductBuilder] Could not refresh charm stock for ' + handle, err);
        });
    })).then(function () {
      self.syncCharmTiles();
    });
  };

  ProductBuilder.prototype.addToCart = function () {
    var self = this;
    var base = this.getBaseVariant();
    if (!base || !this.isVariantPurchasable(base)) return;
    if (!this.validateMinCharms()) return;

    var btn = this.els.addToBagBtn;
    var addToBagLabel = this.config.cta && this.config.cta.add_to_bag
      ? this.config.cta.add_to_bag
      : 'Add to bag';
    setAddToBagButtonLoading(btn, true, addToBagLabel);

    this.refreshCharmCatalog().then(function () {
      return self.refreshBaseVariantStock();
    }).then(function () {
      base = self.getBaseVariant();
      if (!base || !self.isVariantPurchasable(base)) {
        setAddToBagButtonLoading(btn, false, addToBagLabel);
        alert('This product is no longer available.');
        return;
      }

      var stockError = self.validateSelectedCharmStock();
      if (stockError) {
        setAddToBagButtonLoading(btn, false, addToBagLabel);
        alert(stockError);
        self.renderCharmGrid();
        return;
      }

      if (!self.builderId) {
        self.builderId = generateBuilderId();
      }

      var design = self.getDesignLabel();
      var queue = [];

      queue.push({
        id: Number(base.id),
        quantity: 1,
        properties: {
          '_builder_id': self.builderId,
          '_builder_role': 'base',
          'Charms': design
        }
      });

      self.forEachSelectedCharm(function (charm, slotIndex, sequence) {
        var properties = {
          '_builder_id': self.builderId,
          '_builder_role': 'charm',
          '_position': String(sequence + 1),
          '_slot': String(slotIndex + 1),
          '_Design': design
        };

        if (self.hasSlotGroups()) {
          properties.Slot = self.getSlotPlacementLabel(slotIndex);
        }

        if (charm.charmType === 'letter') {
          properties._Letter = charm.letter;
        } else {
          properties._Charm = charm.label || charm.letter;
        }

        if (charm.engraving && charm.engraving.enabled) {
          properties.Letters = charm.engraving.letters;
          properties['Engraving Option'] = charm.engraving.option || 'Letters';
          properties.Engraved = 'Yes';
        }

        if (self.isComplementaryCharmIndex(sequence)) {
          properties['_complementary'] = 'true';
          properties['_Complementary'] = self.getComplementaryLabel();
        }

        queue.push({
          id: Number(charm.id),
          quantity: 1,
          properties: properties
        });
      });

      self.bulkAddToCart(queue, function (success) {
        setAddToBagButtonLoading(btn, false, addToBagLabel);

        if (success) {
          self.setStep('product');
          self.selectedCharms = self.hasSlotGroups() ? self.createEmptySlotStorage() : [];
          self.previewCharmStates = {};
          self.builderId = null;
          self.renderCharmGrid();
          self.renderPreview();
        }
      });
    });
  };

  ProductBuilder.prototype.parseCartError = function (response, fallback, item) {
    if (!response) return fallback;
    if (typeof response === 'string') return response;

    var message = response.description || response.message || fallback;
    if (item && item.id) {
      message += ' (variant ' + item.id + ')';
    }
    return message;
  };

  ProductBuilder.prototype.addCartItemsSequentially = function (items, onComplete) {
    var self = this;
    var index = 0;

    function addNext() {
      if (index >= items.length) {
        self.openCartDrawer(function () {
          onComplete(true);
        });
        return;
      }

      var item = items[index];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: item.id,
          quantity: item.quantity || 1,
          properties: item.properties || {}
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, status: res.status, data: data, item: item };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var message = self.parseCartError(
              result.data,
              'Could not add to bag. Please try again.',
              result.item
            );
            console.error('[ProductBuilder] Cart add failed', result.status, result.data, result.item);
            alert(message);
            onComplete(false);
            return;
          }

          index += 1;
          addNext();
        })
        .catch(function (err) {
          console.error('[ProductBuilder] Cart add failed', err, item);
          alert('Could not add to bag. Please try again.');
          onComplete(false);
        });
    }

    addNext();
  };

  ProductBuilder.prototype.bulkAddToCart = function (items, onComplete) {
    var self = this;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          console.warn('[ProductBuilder] Bulk cart add failed, retrying sequentially', result.status, result.data);
          self.addCartItemsSequentially(items, onComplete);
          return;
        }

        self.openCartDrawer(function () {
          onComplete(true);
        });
      })
      .catch(function (err) {
        console.error('[ProductBuilder] Bulk cart add failed', err);
        self.addCartItemsSequentially(items, onComplete);
      });
  };

  ProductBuilder.prototype.openCartDrawer = function (onDone) {
    var openDrawer = function () {
      setTimeout(function () {
        if (window.jQuery) {
          jQuery('html').addClass('minicart-open');
        } else {
          document.documentElement.classList.add('minicart-open');
        }
        if (onDone) onDone();
      }, 350);
    };

    var syncCart = function (cart) {
      if (window.jQuery) {
        jQuery(document).trigger('cart.requestComplete', [cart]);
      }
      openDrawer();
    };

    if (window.jQuery && typeof CartJS !== 'undefined' && CartJS.getCart) {
      CartJS.getCart({
        success: function (cart) {
          syncCart(cart);
        },
        error: function () {
          jQuery.getJSON('/cart.js', syncCart);
        }
      });
      return;
    }

    if (window.jQuery) {
      jQuery.getJSON('/cart.js', syncCart);
      return;
    }

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(syncCart)
      .catch(openDrawer);
  };

  ProductBuilder.prototype.bindEvents = function () {
    var self = this;

    if (this.els.launch) {
      this.els.launch.addEventListener('click', function () {
        self.syncVariantFromProductForm();
        if (!self.isBaseVariantAvailable()) return;
        self.resetBuilderSelection();
        self.builderId = generateBuilderId();
        self.updateBasePreview();
        self.refreshCharmCatalog().then(function () {
          self.renderCharmGrid();
          self.setStep('choose');
        });
      });
    }

    var masterSelect = this.getProductFormVariantSelect();
    if (masterSelect) {
      masterSelect.addEventListener('change', function () {
        var liveVariant = (window.variants || []).find(function (variant) {
          return Number(variant.id) === Number(masterSelect.value);
        });
        if (liveVariant) {
          self.applyBaseVariantFromLive(liveVariant);
        } else {
          self.syncVariantFromProductForm();
        }
        self.updateLaunchButton();
        if (self.step !== 'product') {
          self.renderPreview();
        }
      });
    }

    var productSection = document.querySelector('[data-section-type="product"]');
    if (productSection) {
      productSection.addEventListener('change', function (event) {
        if (!event.target.matches('[data-single-option-selector]')) return;
        self.syncVariantFromOptionSelectors();
        self.updateLaunchButton();
      });
    }

    if (this.els.backBtn) {
      this.els.backBtn.addEventListener('click', function () {
        if (self.step === 'review') {
          self.setStep('choose');
        } else {
          self.resetBuilderSelection();
          self.setStep('product');
        }
      });
    }

    if (this.els.reviewBtn) {
      this.els.reviewBtn.addEventListener('click', function () {
        if (!self.validateMinCharms()) return;
        self.setStep('review');
      });
    }

    if (this.els.addToBagBtn) {
      this.els.addToBagBtn.addEventListener('click', function () {
        self.addToCart();
      });
    }

    if (this.els.editBtn) {
      this.els.editBtn.addEventListener('click', function () {
        self.openEditDrawer();
      });
      this.els.editBtn.addEventListener('animationend', function (event) {
        if (event.animationName === 'product-builder-edit-btn-enter') {
          self.els.editBtn.classList.remove('is-entering');
        }
      });
    }

    if (this.els.charmsLayer) {
      this.els.charmsLayer.addEventListener('click', function (event) {
        if (self.step !== 'choose') return;
        if (!event.target || !event.target.classList.contains('product-builder__charm-on-canvas')) return;
        if (!self.getSelectedCharmCount()) return;
        self.openEditDrawer();
      });
    }

    if (this.els.closeEdit) {
      this.els.closeEdit.addEventListener('click', function () {
        self.setStep('choose');
      });
    }

    if (this.els.editBackdrop) {
      this.els.editBackdrop.addEventListener('click', function () {
        self.setStep('choose');
      });
    }

    if (this.els.saveEdit) {
      this.els.saveEdit.addEventListener('click', function () {
        self.renderCharmGrid();
        self.setStep('choose');
      });
    }

    if (this.els.closeEngrave) {
      this.els.closeEngrave.addEventListener('click', function () {
        self.closeCharmEngravingPanel();
      });
    }

    if (this.els.engraveBackdrop) {
      this.els.engraveBackdrop.addEventListener('click', function () {
        self.closeCharmEngravingPanel();
      });
    }

    if (this.els.engraveSkip) {
      this.els.engraveSkip.addEventListener('click', function () {
        self.confirmCharmEngraving(false);
      });
    }

    if (this.els.engraveConfirm) {
      this.els.engraveConfirm.addEventListener('click', function () {
        self.confirmCharmEngraving(true);
      });
    }

    if (this.els.engraveInput) {
      this.els.engraveInput.addEventListener('input', function () {
        if (!self.pendingEngraveTile) return;

        var config = self.getCharmEngravingConfig(self.pendingEngraveTile) || {};
        var maxLetters = parsePositiveInt(config.max_letters);
        if (maxLetters === null) maxLetters = 3;
        var normalized = self.normalizeEngravingLetters(self.els.engraveInput.value, maxLetters);

        if (self.els.engraveInput.value !== normalized) {
          self.els.engraveInput.value = normalized;
        }

        self.showEngraveError('');
      });

      this.els.engraveInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          self.confirmCharmEngraving(true);
        }
      });
    }

    if (this.els.startOrder) {
      this.els.startOrder.addEventListener('click', function () {
        self.startOver();
      });
    }

    if (this.els.bespokeCharmsToggle) {
      this.els.bespokeCharmsToggle.addEventListener('click', function () {
        if (!self.els.bespokeCharmsMessage) return;

        var isOpen = !self.els.bespokeCharmsMessage.hidden;
        self.els.bespokeCharmsMessage.hidden = isOpen;
        self.els.bespokeCharmsToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    }

    window.addEventListener('resize', function () {
      self.applyPreviewAppearance();
      self.renderPreview();
      self.syncEngraveGalleryLayout();
    });
  };

  ProductBuilder.prototype.ensureLaunchVisible = function () {
    this.updateLaunchButton();
  };

  ProductBuilder.prototype.init = function () {
    if (!this.data || !this.data.config) {
      console.warn('[ProductBuilder] Missing config');
      return;
    }

    var self = this;
    this.bindEvents();
    this.syncVariantFromProductForm();
    this.updateLaunchButton();
    this.normalizeCharmGroups();
    this.applyPreviewAppearance();

    var productContainer = document.querySelector('[data-section-type="product"]');
    if (productContainer && typeof jQuery !== 'undefined') {
      jQuery(productContainer).on('variantChange', function (event) {
        var variant = event.variant;
        if (variant) {
          self.applyBaseVariantFromLive(variant);
        } else {
          self.syncVariantFromOptionSelectors();
        }
        self.updateLaunchButton();
        if (self.step !== 'product') {
          self.renderPreview();
        }
      });
    }

    this.refreshCharmCatalog().then(function () {
      self.renderCharmGrid();
      self.updateRunningTotal();

      if (!self.charmTiles.length) {
        console.warn('[ProductBuilder] No charm tiles available after loading product data');
      }
    });
  };

  ready(function () {
    var root = document.getElementById('product-builder');
    if (!root) return;

    var data = parseBootstrap();
    if (!data) return;

    var builder = new ProductBuilder(root, data);
    window.__productBuilder = builder;
    builder.init();
  });
})();
